
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $90bfe889a3a444a8$exports = {};

$parcel$export($90bfe889a3a444a8$exports, "create", () => $90bfe889a3a444a8$export$185802fd694ee1f5);
$parcel$export($90bfe889a3a444a8$exports, "clone", () => $90bfe889a3a444a8$export$9cd59f9826255e47);
$parcel$export($90bfe889a3a444a8$exports, "copy", () => $90bfe889a3a444a8$export$784d13d8ee351f07);
$parcel$export($90bfe889a3a444a8$exports, "fromValues", () => $90bfe889a3a444a8$export$a82be99ed2a44a7d);
$parcel$export($90bfe889a3a444a8$exports, "set", () => $90bfe889a3a444a8$export$adaa4cf7ef1b65be);
$parcel$export($90bfe889a3a444a8$exports, "identity", () => $90bfe889a3a444a8$export$f0954fd7d5368655);
$parcel$export($90bfe889a3a444a8$exports, "transpose", () => $90bfe889a3a444a8$export$9cb09a71b7d66923);
$parcel$export($90bfe889a3a444a8$exports, "invert", () => $90bfe889a3a444a8$export$6897c284b6f9f4dc);
$parcel$export($90bfe889a3a444a8$exports, "adjoint", () => $90bfe889a3a444a8$export$33f3c024b4ae00a1);
$parcel$export($90bfe889a3a444a8$exports, "determinant", () => $90bfe889a3a444a8$export$a04698f914c55ed9);
$parcel$export($90bfe889a3a444a8$exports, "multiply", () => $90bfe889a3a444a8$export$2060d2db72cce88f);
$parcel$export($90bfe889a3a444a8$exports, "translate", () => $90bfe889a3a444a8$export$d73ee8ef04f5226a);
$parcel$export($90bfe889a3a444a8$exports, "scale", () => $90bfe889a3a444a8$export$dcdf75081b88279d);
$parcel$export($90bfe889a3a444a8$exports, "rotate", () => $90bfe889a3a444a8$export$bb628a54ab399bc9);
$parcel$export($90bfe889a3a444a8$exports, "rotateX", () => $90bfe889a3a444a8$export$a59c8716592e09af);
$parcel$export($90bfe889a3a444a8$exports, "rotateY", () => $90bfe889a3a444a8$export$cf71e4d4ca4d1cfd);
$parcel$export($90bfe889a3a444a8$exports, "rotateZ", () => $90bfe889a3a444a8$export$ea6eae3365de5b9c);
$parcel$export($90bfe889a3a444a8$exports, "fromTranslation", () => $90bfe889a3a444a8$export$bc9e79e74e9fddf6);
$parcel$export($90bfe889a3a444a8$exports, "fromScaling", () => $90bfe889a3a444a8$export$832ca188ffb1955d);
$parcel$export($90bfe889a3a444a8$exports, "fromRotation", () => $90bfe889a3a444a8$export$926fc125ff3c666c);
$parcel$export($90bfe889a3a444a8$exports, "fromXRotation", () => $90bfe889a3a444a8$export$dd47cc2f828c32ef);
$parcel$export($90bfe889a3a444a8$exports, "fromYRotation", () => $90bfe889a3a444a8$export$7dc997d67d2b7f33);
$parcel$export($90bfe889a3a444a8$exports, "fromZRotation", () => $90bfe889a3a444a8$export$ad5ddaedc8f405df);
$parcel$export($90bfe889a3a444a8$exports, "fromRotationTranslation", () => $90bfe889a3a444a8$export$9545ac307f2a256b);
$parcel$export($90bfe889a3a444a8$exports, "fromQuat2", () => $90bfe889a3a444a8$export$ff497f2be31cc6a);
$parcel$export($90bfe889a3a444a8$exports, "getTranslation", () => $90bfe889a3a444a8$export$202e99f82f7f0395);
$parcel$export($90bfe889a3a444a8$exports, "getScaling", () => $90bfe889a3a444a8$export$71dc54d92bd04b57);
$parcel$export($90bfe889a3a444a8$exports, "getRotation", () => $90bfe889a3a444a8$export$df3937d3b537df0a);
$parcel$export($90bfe889a3a444a8$exports, "fromRotationTranslationScale", () => $90bfe889a3a444a8$export$ddf9c55c9f2be172);
$parcel$export($90bfe889a3a444a8$exports, "fromRotationTranslationScaleOrigin", () => $90bfe889a3a444a8$export$1def1f860edc4b1f);
$parcel$export($90bfe889a3a444a8$exports, "fromQuat", () => $90bfe889a3a444a8$export$2ff2bbe382249af7);
$parcel$export($90bfe889a3a444a8$exports, "frustum", () => $90bfe889a3a444a8$export$89b5708c387cac6c);
$parcel$export($90bfe889a3a444a8$exports, "perspectiveNO", () => $90bfe889a3a444a8$export$4cf19729ec9a96b8);
$parcel$export($90bfe889a3a444a8$exports, "perspective", () => $90bfe889a3a444a8$export$541149539f3a4684);
$parcel$export($90bfe889a3a444a8$exports, "perspectiveZO", () => $90bfe889a3a444a8$export$294bba99a6af0c0c);
$parcel$export($90bfe889a3a444a8$exports, "perspectiveFromFieldOfView", () => $90bfe889a3a444a8$export$58ae211c788e338f);
$parcel$export($90bfe889a3a444a8$exports, "orthoNO", () => $90bfe889a3a444a8$export$c5f65ef3eb668f27);
$parcel$export($90bfe889a3a444a8$exports, "ortho", () => $90bfe889a3a444a8$export$4f2167e613cfc87b);
$parcel$export($90bfe889a3a444a8$exports, "orthoZO", () => $90bfe889a3a444a8$export$b1d31ea7b4d854e);
$parcel$export($90bfe889a3a444a8$exports, "lookAt", () => $90bfe889a3a444a8$export$d924e14fd6d9aa66);
$parcel$export($90bfe889a3a444a8$exports, "targetTo", () => $90bfe889a3a444a8$export$aa67782f4dc9e52c);
$parcel$export($90bfe889a3a444a8$exports, "str", () => $90bfe889a3a444a8$export$42d51816ce590c93);
$parcel$export($90bfe889a3a444a8$exports, "frob", () => $90bfe889a3a444a8$export$326827e8268e9cdb);
$parcel$export($90bfe889a3a444a8$exports, "add", () => $90bfe889a3a444a8$export$e16d8520af44a096);
$parcel$export($90bfe889a3a444a8$exports, "subtract", () => $90bfe889a3a444a8$export$4e2d2ead65e5f7e3);
$parcel$export($90bfe889a3a444a8$exports, "multiplyScalar", () => $90bfe889a3a444a8$export$c697bed75648cdb7);
$parcel$export($90bfe889a3a444a8$exports, "multiplyScalarAndAdd", () => $90bfe889a3a444a8$export$553579f63bdd7137);
$parcel$export($90bfe889a3a444a8$exports, "exactEquals", () => $90bfe889a3a444a8$export$f2599a5cf1109d8);
$parcel$export($90bfe889a3a444a8$exports, "equals", () => $90bfe889a3a444a8$export$e9bab7fafb253603);
$parcel$export($90bfe889a3a444a8$exports, "mul", () => $90bfe889a3a444a8$export$6e3a27864ab166fe);
$parcel$export($90bfe889a3a444a8$exports, "sub", () => $90bfe889a3a444a8$export$f93b5905241a7cca);
/**
 * Common utilities
 * @module glMatrix
 */ // Configuration Constants
var $025278b023032180$export$fd293b15f47e270 = 0.000001;
var $025278b023032180$export$b67359430d3b1b2 = typeof Float32Array !== "undefined" ? Float32Array : Array;
var $025278b023032180$export$5ada478c8a628231 = Math.random;
function $025278b023032180$export$cb2c0eb57f5e532c(type) {
    $025278b023032180$export$b67359430d3b1b2 = type;
}
var $025278b023032180$var$degree = Math.PI / 180;
function $025278b023032180$export$408b8ee5959eefd5(a) {
    return a * $025278b023032180$var$degree;
}
function $025278b023032180$export$e9bab7fafb253603(a, b) {
    return Math.abs(a - b) <= $025278b023032180$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a), Math.abs(b));
}
if (!Math.hypot) Math.hypot = function() {
    var y = 0, i = arguments.length;
    while(i--)y += arguments[i] * arguments[i];
    return Math.sqrt(y);
};


function $90bfe889a3a444a8$export$185802fd694ee1f5() {
    var out = new $025278b023032180$export$b67359430d3b1b2(16);
    if ($025278b023032180$export$b67359430d3b1b2 != Float32Array) {
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[4] = 0;
        out[6] = 0;
        out[7] = 0;
        out[8] = 0;
        out[9] = 0;
        out[11] = 0;
        out[12] = 0;
        out[13] = 0;
        out[14] = 0;
    }
    out[0] = 1;
    out[5] = 1;
    out[10] = 1;
    out[15] = 1;
    return out;
}
function $90bfe889a3a444a8$export$9cd59f9826255e47(a) {
    var out = new $025278b023032180$export$b67359430d3b1b2(16);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $90bfe889a3a444a8$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $90bfe889a3a444a8$export$a82be99ed2a44a7d(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    var out = new $025278b023032180$export$b67359430d3b1b2(16);
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
function $90bfe889a3a444a8$export$adaa4cf7ef1b65be(out, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
function $90bfe889a3a444a8$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $90bfe889a3a444a8$export$9cb09a71b7d66923(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        var a01 = a[1], a02 = a[2], a03 = a[3];
        var a12 = a[6], a13 = a[7];
        var a23 = a[11];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a01;
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a02;
        out[9] = a12;
        out[11] = a[14];
        out[12] = a03;
        out[13] = a13;
        out[14] = a23;
    } else {
        out[0] = a[0];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a[1];
        out[5] = a[5];
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a[2];
        out[9] = a[6];
        out[10] = a[10];
        out[11] = a[14];
        out[12] = a[3];
        out[13] = a[7];
        out[14] = a[11];
        out[15] = a[15];
    }
    return out;
}
function $90bfe889a3a444a8$export$6897c284b6f9f4dc(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32; // Calculate the determinant
    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
    out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
    out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
    out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
    out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
    out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
    out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
    return out;
}
function $90bfe889a3a444a8$export$33f3c024b4ae00a1(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    out[0] = a11 * (a22 * a33 - a23 * a32) - a21 * (a12 * a33 - a13 * a32) + a31 * (a12 * a23 - a13 * a22);
    out[1] = -(a01 * (a22 * a33 - a23 * a32) - a21 * (a02 * a33 - a03 * a32) + a31 * (a02 * a23 - a03 * a22));
    out[2] = a01 * (a12 * a33 - a13 * a32) - a11 * (a02 * a33 - a03 * a32) + a31 * (a02 * a13 - a03 * a12);
    out[3] = -(a01 * (a12 * a23 - a13 * a22) - a11 * (a02 * a23 - a03 * a22) + a21 * (a02 * a13 - a03 * a12));
    out[4] = -(a10 * (a22 * a33 - a23 * a32) - a20 * (a12 * a33 - a13 * a32) + a30 * (a12 * a23 - a13 * a22));
    out[5] = a00 * (a22 * a33 - a23 * a32) - a20 * (a02 * a33 - a03 * a32) + a30 * (a02 * a23 - a03 * a22);
    out[6] = -(a00 * (a12 * a33 - a13 * a32) - a10 * (a02 * a33 - a03 * a32) + a30 * (a02 * a13 - a03 * a12));
    out[7] = a00 * (a12 * a23 - a13 * a22) - a10 * (a02 * a23 - a03 * a22) + a20 * (a02 * a13 - a03 * a12);
    out[8] = a10 * (a21 * a33 - a23 * a31) - a20 * (a11 * a33 - a13 * a31) + a30 * (a11 * a23 - a13 * a21);
    out[9] = -(a00 * (a21 * a33 - a23 * a31) - a20 * (a01 * a33 - a03 * a31) + a30 * (a01 * a23 - a03 * a21));
    out[10] = a00 * (a11 * a33 - a13 * a31) - a10 * (a01 * a33 - a03 * a31) + a30 * (a01 * a13 - a03 * a11);
    out[11] = -(a00 * (a11 * a23 - a13 * a21) - a10 * (a01 * a23 - a03 * a21) + a20 * (a01 * a13 - a03 * a11));
    out[12] = -(a10 * (a21 * a32 - a22 * a31) - a20 * (a11 * a32 - a12 * a31) + a30 * (a11 * a22 - a12 * a21));
    out[13] = a00 * (a21 * a32 - a22 * a31) - a20 * (a01 * a32 - a02 * a31) + a30 * (a01 * a22 - a02 * a21);
    out[14] = -(a00 * (a11 * a32 - a12 * a31) - a10 * (a01 * a32 - a02 * a31) + a30 * (a01 * a12 - a02 * a11));
    out[15] = a00 * (a11 * a22 - a12 * a21) - a10 * (a01 * a22 - a02 * a21) + a20 * (a01 * a12 - a02 * a11);
    return out;
}
function $90bfe889a3a444a8$export$a04698f914c55ed9(a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32; // Calculate the determinant
    return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
}
function $90bfe889a3a444a8$export$2060d2db72cce88f(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15]; // Cache only the current line of the second matrix
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[4];
    b1 = b[5];
    b2 = b[6];
    b3 = b[7];
    out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[8];
    b1 = b[9];
    b2 = b[10];
    b3 = b[11];
    out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[12];
    b1 = b[13];
    b2 = b[14];
    b3 = b[15];
    out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    return out;
}
function $90bfe889a3a444a8$export$d73ee8ef04f5226a(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    var a00, a01, a02, a03;
    var a10, a11, a12, a13;
    var a20, a21, a22, a23;
    if (a === out) {
        out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
        out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
        out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
        out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
    } else {
        a00 = a[0];
        a01 = a[1];
        a02 = a[2];
        a03 = a[3];
        a10 = a[4];
        a11 = a[5];
        a12 = a[6];
        a13 = a[7];
        a20 = a[8];
        a21 = a[9];
        a22 = a[10];
        a23 = a[11];
        out[0] = a00;
        out[1] = a01;
        out[2] = a02;
        out[3] = a03;
        out[4] = a10;
        out[5] = a11;
        out[6] = a12;
        out[7] = a13;
        out[8] = a20;
        out[9] = a21;
        out[10] = a22;
        out[11] = a23;
        out[12] = a00 * x + a10 * y + a20 * z + a[12];
        out[13] = a01 * x + a11 * y + a21 * z + a[13];
        out[14] = a02 * x + a12 * y + a22 * z + a[14];
        out[15] = a03 * x + a13 * y + a23 * z + a[15];
    }
    return out;
}
function $90bfe889a3a444a8$export$dcdf75081b88279d(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    out[0] = a[0] * x;
    out[1] = a[1] * x;
    out[2] = a[2] * x;
    out[3] = a[3] * x;
    out[4] = a[4] * y;
    out[5] = a[5] * y;
    out[6] = a[6] * y;
    out[7] = a[7] * y;
    out[8] = a[8] * z;
    out[9] = a[9] * z;
    out[10] = a[10] * z;
    out[11] = a[11] * z;
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $90bfe889a3a444a8$export$bb628a54ab399bc9(out, a, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2];
    var len = Math.hypot(x, y, z);
    var s, c, t;
    var a00, a01, a02, a03;
    var a10, a11, a12, a13;
    var a20, a21, a22, a23;
    var b00, b01, b02;
    var b10, b11, b12;
    var b20, b21, b22;
    if (len < $025278b023032180$export$fd293b15f47e270) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c;
    a00 = a[0];
    a01 = a[1];
    a02 = a[2];
    a03 = a[3];
    a10 = a[4];
    a11 = a[5];
    a12 = a[6];
    a13 = a[7];
    a20 = a[8];
    a21 = a[9];
    a22 = a[10];
    a23 = a[11]; // Construct the elements of the rotation matrix
    b00 = x * x * t + c;
    b01 = y * x * t + z * s;
    b02 = z * x * t - y * s;
    b10 = x * y * t - z * s;
    b11 = y * y * t + c;
    b12 = z * y * t + x * s;
    b20 = x * z * t + y * s;
    b21 = y * z * t - x * s;
    b22 = z * z * t + c; // Perform rotation-specific matrix multiplication
    out[0] = a00 * b00 + a10 * b01 + a20 * b02;
    out[1] = a01 * b00 + a11 * b01 + a21 * b02;
    out[2] = a02 * b00 + a12 * b01 + a22 * b02;
    out[3] = a03 * b00 + a13 * b01 + a23 * b02;
    out[4] = a00 * b10 + a10 * b11 + a20 * b12;
    out[5] = a01 * b10 + a11 * b11 + a21 * b12;
    out[6] = a02 * b10 + a12 * b11 + a22 * b12;
    out[7] = a03 * b10 + a13 * b11 + a23 * b12;
    out[8] = a00 * b20 + a10 * b21 + a20 * b22;
    out[9] = a01 * b20 + a11 * b21 + a21 * b22;
    out[10] = a02 * b20 + a12 * b21 + a22 * b22;
    out[11] = a03 * b20 + a13 * b21 + a23 * b22;
    if (a !== out) {
        // If the source and destination differ, copy the unchanged last row
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    return out;
}
function $90bfe889a3a444a8$export$a59c8716592e09af(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a10 = a[4];
    var a11 = a[5];
    var a12 = a[6];
    var a13 = a[7];
    var a20 = a[8];
    var a21 = a[9];
    var a22 = a[10];
    var a23 = a[11];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged rows
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[3];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[4] = a10 * c + a20 * s;
    out[5] = a11 * c + a21 * s;
    out[6] = a12 * c + a22 * s;
    out[7] = a13 * c + a23 * s;
    out[8] = a20 * c - a10 * s;
    out[9] = a21 * c - a11 * s;
    out[10] = a22 * c - a12 * s;
    out[11] = a23 * c - a13 * s;
    return out;
}
function $90bfe889a3a444a8$export$cf71e4d4ca4d1cfd(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a00 = a[0];
    var a01 = a[1];
    var a02 = a[2];
    var a03 = a[3];
    var a20 = a[8];
    var a21 = a[9];
    var a22 = a[10];
    var a23 = a[11];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged rows
        out[4] = a[4];
        out[5] = a[5];
        out[6] = a[6];
        out[7] = a[7];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[0] = a00 * c - a20 * s;
    out[1] = a01 * c - a21 * s;
    out[2] = a02 * c - a22 * s;
    out[3] = a03 * c - a23 * s;
    out[8] = a00 * s + a20 * c;
    out[9] = a01 * s + a21 * c;
    out[10] = a02 * s + a22 * c;
    out[11] = a03 * s + a23 * c;
    return out;
}
function $90bfe889a3a444a8$export$ea6eae3365de5b9c(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a00 = a[0];
    var a01 = a[1];
    var a02 = a[2];
    var a03 = a[3];
    var a10 = a[4];
    var a11 = a[5];
    var a12 = a[6];
    var a13 = a[7];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged last row
        out[8] = a[8];
        out[9] = a[9];
        out[10] = a[10];
        out[11] = a[11];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[0] = a00 * c + a10 * s;
    out[1] = a01 * c + a11 * s;
    out[2] = a02 * c + a12 * s;
    out[3] = a03 * c + a13 * s;
    out[4] = a10 * c - a00 * s;
    out[5] = a11 * c - a01 * s;
    out[6] = a12 * c - a02 * s;
    out[7] = a13 * c - a03 * s;
    return out;
}
function $90bfe889a3a444a8$export$bc9e79e74e9fddf6(out, v) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $90bfe889a3a444a8$export$832ca188ffb1955d(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = v[1];
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = v[2];
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $90bfe889a3a444a8$export$926fc125ff3c666c(out, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2];
    var len = Math.hypot(x, y, z);
    var s, c, t;
    if (len < $025278b023032180$export$fd293b15f47e270) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c; // Perform rotation-specific matrix multiplication
    out[0] = x * x * t + c;
    out[1] = y * x * t + z * s;
    out[2] = z * x * t - y * s;
    out[3] = 0;
    out[4] = x * y * t - z * s;
    out[5] = y * y * t + c;
    out[6] = z * y * t + x * s;
    out[7] = 0;
    out[8] = x * z * t + y * s;
    out[9] = y * z * t - x * s;
    out[10] = z * z * t + c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $90bfe889a3a444a8$export$dd47cc2f828c32ef(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = c;
    out[6] = s;
    out[7] = 0;
    out[8] = 0;
    out[9] = -s;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $90bfe889a3a444a8$export$7dc997d67d2b7f33(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = 0;
    out[2] = -s;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = s;
    out[9] = 0;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $90bfe889a3a444a8$export$ad5ddaedc8f405df(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = s;
    out[2] = 0;
    out[3] = 0;
    out[4] = -s;
    out[5] = c;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $90bfe889a3a444a8$export$9545ac307f2a256b(out, q, v) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - (yy + zz);
    out[1] = xy + wz;
    out[2] = xz - wy;
    out[3] = 0;
    out[4] = xy - wz;
    out[5] = 1 - (xx + zz);
    out[6] = yz + wx;
    out[7] = 0;
    out[8] = xz + wy;
    out[9] = yz - wx;
    out[10] = 1 - (xx + yy);
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $90bfe889a3a444a8$export$ff497f2be31cc6a(out, a) {
    var translation = new $025278b023032180$export$b67359430d3b1b2(3);
    var bx = -a[0], by = -a[1], bz = -a[2], bw = a[3], ax = a[4], ay = a[5], az = a[6], aw = a[7];
    var magnitude = bx * bx + by * by + bz * bz + bw * bw; //Only scale if it makes sense
    if (magnitude > 0) {
        translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2 / magnitude;
        translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2 / magnitude;
        translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2 / magnitude;
    } else {
        translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2;
        translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2;
        translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2;
    }
    $90bfe889a3a444a8$export$9545ac307f2a256b(out, a, translation);
    return out;
}
function $90bfe889a3a444a8$export$202e99f82f7f0395(out, mat) {
    out[0] = mat[12];
    out[1] = mat[13];
    out[2] = mat[14];
    return out;
}
function $90bfe889a3a444a8$export$71dc54d92bd04b57(out, mat) {
    var m11 = mat[0];
    var m12 = mat[1];
    var m13 = mat[2];
    var m21 = mat[4];
    var m22 = mat[5];
    var m23 = mat[6];
    var m31 = mat[8];
    var m32 = mat[9];
    var m33 = mat[10];
    out[0] = Math.hypot(m11, m12, m13);
    out[1] = Math.hypot(m21, m22, m23);
    out[2] = Math.hypot(m31, m32, m33);
    return out;
}
function $90bfe889a3a444a8$export$df3937d3b537df0a(out, mat) {
    var scaling = new $025278b023032180$export$b67359430d3b1b2(3);
    $90bfe889a3a444a8$export$71dc54d92bd04b57(scaling, mat);
    var is1 = 1 / scaling[0];
    var is2 = 1 / scaling[1];
    var is3 = 1 / scaling[2];
    var sm11 = mat[0] * is1;
    var sm12 = mat[1] * is2;
    var sm13 = mat[2] * is3;
    var sm21 = mat[4] * is1;
    var sm22 = mat[5] * is2;
    var sm23 = mat[6] * is3;
    var sm31 = mat[8] * is1;
    var sm32 = mat[9] * is2;
    var sm33 = mat[10] * is3;
    var trace = sm11 + sm22 + sm33;
    var S = 0;
    if (trace > 0) {
        S = Math.sqrt(trace + 1.0) * 2;
        out[3] = 0.25 * S;
        out[0] = (sm23 - sm32) / S;
        out[1] = (sm31 - sm13) / S;
        out[2] = (sm12 - sm21) / S;
    } else if (sm11 > sm22 && sm11 > sm33) {
        S = Math.sqrt(1.0 + sm11 - sm22 - sm33) * 2;
        out[3] = (sm23 - sm32) / S;
        out[0] = 0.25 * S;
        out[1] = (sm12 + sm21) / S;
        out[2] = (sm31 + sm13) / S;
    } else if (sm22 > sm33) {
        S = Math.sqrt(1.0 + sm22 - sm11 - sm33) * 2;
        out[3] = (sm31 - sm13) / S;
        out[0] = (sm12 + sm21) / S;
        out[1] = 0.25 * S;
        out[2] = (sm23 + sm32) / S;
    } else {
        S = Math.sqrt(1.0 + sm33 - sm11 - sm22) * 2;
        out[3] = (sm12 - sm21) / S;
        out[0] = (sm31 + sm13) / S;
        out[1] = (sm23 + sm32) / S;
        out[2] = 0.25 * S;
    }
    return out;
}
function $90bfe889a3a444a8$export$ddf9c55c9f2be172(out, q, v, s) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    var sx = s[0];
    var sy = s[1];
    var sz = s[2];
    out[0] = (1 - (yy + zz)) * sx;
    out[1] = (xy + wz) * sx;
    out[2] = (xz - wy) * sx;
    out[3] = 0;
    out[4] = (xy - wz) * sy;
    out[5] = (1 - (xx + zz)) * sy;
    out[6] = (yz + wx) * sy;
    out[7] = 0;
    out[8] = (xz + wy) * sz;
    out[9] = (yz - wx) * sz;
    out[10] = (1 - (xx + yy)) * sz;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $90bfe889a3a444a8$export$1def1f860edc4b1f(out, q, v, s, o) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    var sx = s[0];
    var sy = s[1];
    var sz = s[2];
    var ox = o[0];
    var oy = o[1];
    var oz = o[2];
    var out0 = (1 - (yy + zz)) * sx;
    var out1 = (xy + wz) * sx;
    var out2 = (xz - wy) * sx;
    var out4 = (xy - wz) * sy;
    var out5 = (1 - (xx + zz)) * sy;
    var out6 = (yz + wx) * sy;
    var out8 = (xz + wy) * sz;
    var out9 = (yz - wx) * sz;
    var out10 = (1 - (xx + yy)) * sz;
    out[0] = out0;
    out[1] = out1;
    out[2] = out2;
    out[3] = 0;
    out[4] = out4;
    out[5] = out5;
    out[6] = out6;
    out[7] = 0;
    out[8] = out8;
    out[9] = out9;
    out[10] = out10;
    out[11] = 0;
    out[12] = v[0] + ox - (out0 * ox + out4 * oy + out8 * oz);
    out[13] = v[1] + oy - (out1 * ox + out5 * oy + out9 * oz);
    out[14] = v[2] + oz - (out2 * ox + out6 * oy + out10 * oz);
    out[15] = 1;
    return out;
}
function $90bfe889a3a444a8$export$2ff2bbe382249af7(out, q) {
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var yx = y * x2;
    var yy = y * y2;
    var zx = z * x2;
    var zy = z * y2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - yy - zz;
    out[1] = yx + wz;
    out[2] = zx - wy;
    out[3] = 0;
    out[4] = yx - wz;
    out[5] = 1 - xx - zz;
    out[6] = zy + wx;
    out[7] = 0;
    out[8] = zx + wy;
    out[9] = zy - wx;
    out[10] = 1 - xx - yy;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $90bfe889a3a444a8$export$89b5708c387cac6c(out, left, right, bottom, top, near, far) {
    var rl = 1 / (right - left);
    var tb = 1 / (top - bottom);
    var nf = 1 / (near - far);
    out[0] = near * 2 * rl;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = near * 2 * tb;
    out[6] = 0;
    out[7] = 0;
    out[8] = (right + left) * rl;
    out[9] = (top + bottom) * tb;
    out[10] = (far + near) * nf;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[14] = far * near * 2 * nf;
    out[15] = 0;
    return out;
}
function $90bfe889a3a444a8$export$4cf19729ec9a96b8(out, fovy, aspect, near, far) {
    var f = 1.0 / Math.tan(fovy / 2), nf;
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[15] = 0;
    if (far != null && far !== Infinity) {
        nf = 1 / (near - far);
        out[10] = (far + near) * nf;
        out[14] = 2 * far * near * nf;
    } else {
        out[10] = -1;
        out[14] = -2 * near;
    }
    return out;
}
var $90bfe889a3a444a8$export$541149539f3a4684 = $90bfe889a3a444a8$export$4cf19729ec9a96b8;
function $90bfe889a3a444a8$export$294bba99a6af0c0c(out, fovy, aspect, near, far) {
    var f = 1.0 / Math.tan(fovy / 2), nf;
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[15] = 0;
    if (far != null && far !== Infinity) {
        nf = 1 / (near - far);
        out[10] = far * nf;
        out[14] = far * near * nf;
    } else {
        out[10] = -1;
        out[14] = -near;
    }
    return out;
}
function $90bfe889a3a444a8$export$58ae211c788e338f(out, fov, near, far) {
    var upTan = Math.tan(fov.upDegrees * Math.PI / 180.0);
    var downTan = Math.tan(fov.downDegrees * Math.PI / 180.0);
    var leftTan = Math.tan(fov.leftDegrees * Math.PI / 180.0);
    var rightTan = Math.tan(fov.rightDegrees * Math.PI / 180.0);
    var xScale = 2.0 / (leftTan + rightTan);
    var yScale = 2.0 / (upTan + downTan);
    out[0] = xScale;
    out[1] = 0.0;
    out[2] = 0.0;
    out[3] = 0.0;
    out[4] = 0.0;
    out[5] = yScale;
    out[6] = 0.0;
    out[7] = 0.0;
    out[8] = -((leftTan - rightTan) * xScale * 0.5);
    out[9] = (upTan - downTan) * yScale * 0.5;
    out[10] = far / (near - far);
    out[11] = -1;
    out[12] = 0.0;
    out[13] = 0.0;
    out[14] = far * near / (near - far);
    out[15] = 0.0;
    return out;
}
function $90bfe889a3a444a8$export$c5f65ef3eb668f27(out, left, right, bottom, top, near, far) {
    var lr = 1 / (left - right);
    var bt = 1 / (bottom - top);
    var nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 2 * nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = (far + near) * nf;
    out[15] = 1;
    return out;
}
var $90bfe889a3a444a8$export$4f2167e613cfc87b = $90bfe889a3a444a8$export$c5f65ef3eb668f27;
function $90bfe889a3a444a8$export$b1d31ea7b4d854e(out, left, right, bottom, top, near, far) {
    var lr = 1 / (left - right);
    var bt = 1 / (bottom - top);
    var nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = near * nf;
    out[15] = 1;
    return out;
}
function $90bfe889a3a444a8$export$d924e14fd6d9aa66(out, eye, center, up) {
    var x0, x1, x2, y0, y1, y2, z0, z1, z2, len;
    var eyex = eye[0];
    var eyey = eye[1];
    var eyez = eye[2];
    var upx = up[0];
    var upy = up[1];
    var upz = up[2];
    var centerx = center[0];
    var centery = center[1];
    var centerz = center[2];
    if (Math.abs(eyex - centerx) < $025278b023032180$export$fd293b15f47e270 && Math.abs(eyey - centery) < $025278b023032180$export$fd293b15f47e270 && Math.abs(eyez - centerz) < $025278b023032180$export$fd293b15f47e270) return $90bfe889a3a444a8$export$f0954fd7d5368655(out);
    z0 = eyex - centerx;
    z1 = eyey - centery;
    z2 = eyez - centerz;
    len = 1 / Math.hypot(z0, z1, z2);
    z0 *= len;
    z1 *= len;
    z2 *= len;
    x0 = upy * z2 - upz * z1;
    x1 = upz * z0 - upx * z2;
    x2 = upx * z1 - upy * z0;
    len = Math.hypot(x0, x1, x2);
    if (!len) {
        x0 = 0;
        x1 = 0;
        x2 = 0;
    } else {
        len = 1 / len;
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    y0 = z1 * x2 - z2 * x1;
    y1 = z2 * x0 - z0 * x2;
    y2 = z0 * x1 - z1 * x0;
    len = Math.hypot(y0, y1, y2);
    if (!len) {
        y0 = 0;
        y1 = 0;
        y2 = 0;
    } else {
        len = 1 / len;
        y0 *= len;
        y1 *= len;
        y2 *= len;
    }
    out[0] = x0;
    out[1] = y0;
    out[2] = z0;
    out[3] = 0;
    out[4] = x1;
    out[5] = y1;
    out[6] = z1;
    out[7] = 0;
    out[8] = x2;
    out[9] = y2;
    out[10] = z2;
    out[11] = 0;
    out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
    out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
    out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
    out[15] = 1;
    return out;
}
function $90bfe889a3a444a8$export$aa67782f4dc9e52c(out, eye, target, up) {
    var eyex = eye[0], eyey = eye[1], eyez = eye[2], upx = up[0], upy = up[1], upz = up[2];
    var z0 = eyex - target[0], z1 = eyey - target[1], z2 = eyez - target[2];
    var len = z0 * z0 + z1 * z1 + z2 * z2;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        z0 *= len;
        z1 *= len;
        z2 *= len;
    }
    var x0 = upy * z2 - upz * z1, x1 = upz * z0 - upx * z2, x2 = upx * z1 - upy * z0;
    len = x0 * x0 + x1 * x1 + x2 * x2;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    out[0] = x0;
    out[1] = x1;
    out[2] = x2;
    out[3] = 0;
    out[4] = z1 * x2 - z2 * x1;
    out[5] = z2 * x0 - z0 * x2;
    out[6] = z0 * x1 - z1 * x0;
    out[7] = 0;
    out[8] = z0;
    out[9] = z1;
    out[10] = z2;
    out[11] = 0;
    out[12] = eyex;
    out[13] = eyey;
    out[14] = eyez;
    out[15] = 1;
    return out;
}
function $90bfe889a3a444a8$export$42d51816ce590c93(a) {
    return "mat4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ", " + a[8] + ", " + a[9] + ", " + a[10] + ", " + a[11] + ", " + a[12] + ", " + a[13] + ", " + a[14] + ", " + a[15] + ")";
}
function $90bfe889a3a444a8$export$326827e8268e9cdb(a) {
    return Math.hypot(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]);
}
function $90bfe889a3a444a8$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    out[8] = a[8] + b[8];
    out[9] = a[9] + b[9];
    out[10] = a[10] + b[10];
    out[11] = a[11] + b[11];
    out[12] = a[12] + b[12];
    out[13] = a[13] + b[13];
    out[14] = a[14] + b[14];
    out[15] = a[15] + b[15];
    return out;
}
function $90bfe889a3a444a8$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    out[6] = a[6] - b[6];
    out[7] = a[7] - b[7];
    out[8] = a[8] - b[8];
    out[9] = a[9] - b[9];
    out[10] = a[10] - b[10];
    out[11] = a[11] - b[11];
    out[12] = a[12] - b[12];
    out[13] = a[13] - b[13];
    out[14] = a[14] - b[14];
    out[15] = a[15] - b[15];
    return out;
}
function $90bfe889a3a444a8$export$c697bed75648cdb7(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    out[8] = a[8] * b;
    out[9] = a[9] * b;
    out[10] = a[10] * b;
    out[11] = a[11] * b;
    out[12] = a[12] * b;
    out[13] = a[13] * b;
    out[14] = a[14] * b;
    out[15] = a[15] * b;
    return out;
}
function $90bfe889a3a444a8$export$553579f63bdd7137(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    out[4] = a[4] + b[4] * scale;
    out[5] = a[5] + b[5] * scale;
    out[6] = a[6] + b[6] * scale;
    out[7] = a[7] + b[7] * scale;
    out[8] = a[8] + b[8] * scale;
    out[9] = a[9] + b[9] * scale;
    out[10] = a[10] + b[10] * scale;
    out[11] = a[11] + b[11] * scale;
    out[12] = a[12] + b[12] * scale;
    out[13] = a[13] + b[13] * scale;
    out[14] = a[14] + b[14] * scale;
    out[15] = a[15] + b[15] * scale;
    return out;
}
function $90bfe889a3a444a8$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8] && a[9] === b[9] && a[10] === b[10] && a[11] === b[11] && a[12] === b[12] && a[13] === b[13] && a[14] === b[14] && a[15] === b[15];
}
function $90bfe889a3a444a8$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var a4 = a[4], a5 = a[5], a6 = a[6], a7 = a[7];
    var a8 = a[8], a9 = a[9], a10 = a[10], a11 = a[11];
    var a12 = a[12], a13 = a[13], a14 = a[14], a15 = a[15];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    var b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7];
    var b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11];
    var b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    return Math.abs(a0 - b0) <= $025278b023032180$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $025278b023032180$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $025278b023032180$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $025278b023032180$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= $025278b023032180$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= $025278b023032180$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= $025278b023032180$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= $025278b023032180$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= $025278b023032180$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a8), Math.abs(b8)) && Math.abs(a9 - b9) <= $025278b023032180$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a9), Math.abs(b9)) && Math.abs(a10 - b10) <= $025278b023032180$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a10), Math.abs(b10)) && Math.abs(a11 - b11) <= $025278b023032180$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a11), Math.abs(b11)) && Math.abs(a12 - b12) <= $025278b023032180$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a12), Math.abs(b12)) && Math.abs(a13 - b13) <= $025278b023032180$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a13), Math.abs(b13)) && Math.abs(a14 - b14) <= $025278b023032180$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a14), Math.abs(b14)) && Math.abs(a15 - b15) <= $025278b023032180$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a15), Math.abs(b15));
}
var $90bfe889a3a444a8$export$6e3a27864ab166fe = $90bfe889a3a444a8$export$2060d2db72cce88f;
var $90bfe889a3a444a8$export$f93b5905241a7cca = $90bfe889a3a444a8$export$4e2d2ead65e5f7e3;

var $8db1b5da822cad85$exports = {};

$parcel$export($8db1b5da822cad85$exports, "create", () => $8db1b5da822cad85$export$185802fd694ee1f5);
$parcel$export($8db1b5da822cad85$exports, "clone", () => $8db1b5da822cad85$export$9cd59f9826255e47);
$parcel$export($8db1b5da822cad85$exports, "length", () => $8db1b5da822cad85$export$f24224f1c91d8156);
$parcel$export($8db1b5da822cad85$exports, "fromValues", () => $8db1b5da822cad85$export$a82be99ed2a44a7d);
$parcel$export($8db1b5da822cad85$exports, "copy", () => $8db1b5da822cad85$export$784d13d8ee351f07);
$parcel$export($8db1b5da822cad85$exports, "set", () => $8db1b5da822cad85$export$adaa4cf7ef1b65be);
$parcel$export($8db1b5da822cad85$exports, "add", () => $8db1b5da822cad85$export$e16d8520af44a096);
$parcel$export($8db1b5da822cad85$exports, "subtract", () => $8db1b5da822cad85$export$4e2d2ead65e5f7e3);
$parcel$export($8db1b5da822cad85$exports, "multiply", () => $8db1b5da822cad85$export$2060d2db72cce88f);
$parcel$export($8db1b5da822cad85$exports, "divide", () => $8db1b5da822cad85$export$cd007d971a5a2143);
$parcel$export($8db1b5da822cad85$exports, "ceil", () => $8db1b5da822cad85$export$803ce6b71a0a94b2);
$parcel$export($8db1b5da822cad85$exports, "floor", () => $8db1b5da822cad85$export$a3fe094919f356fd);
$parcel$export($8db1b5da822cad85$exports, "min", () => $8db1b5da822cad85$export$96ec731ed4dcb222);
$parcel$export($8db1b5da822cad85$exports, "max", () => $8db1b5da822cad85$export$8960430cfd85939f);
$parcel$export($8db1b5da822cad85$exports, "round", () => $8db1b5da822cad85$export$2077e0241d6afd3c);
$parcel$export($8db1b5da822cad85$exports, "scale", () => $8db1b5da822cad85$export$dcdf75081b88279d);
$parcel$export($8db1b5da822cad85$exports, "scaleAndAdd", () => $8db1b5da822cad85$export$19cedf1da84ba854);
$parcel$export($8db1b5da822cad85$exports, "distance", () => $8db1b5da822cad85$export$9f17032d917177de);
$parcel$export($8db1b5da822cad85$exports, "squaredDistance", () => $8db1b5da822cad85$export$88e6ebb4fe54f538);
$parcel$export($8db1b5da822cad85$exports, "squaredLength", () => $8db1b5da822cad85$export$ab44e1323ffc8376);
$parcel$export($8db1b5da822cad85$exports, "negate", () => $8db1b5da822cad85$export$aef51622e549b8b0);
$parcel$export($8db1b5da822cad85$exports, "inverse", () => $8db1b5da822cad85$export$70ae2c07e401031b);
$parcel$export($8db1b5da822cad85$exports, "normalize", () => $8db1b5da822cad85$export$a3295358bff77e);
$parcel$export($8db1b5da822cad85$exports, "dot", () => $8db1b5da822cad85$export$94132a0e348806d4);
$parcel$export($8db1b5da822cad85$exports, "cross", () => $8db1b5da822cad85$export$bb646b20bb93d339);
$parcel$export($8db1b5da822cad85$exports, "lerp", () => $8db1b5da822cad85$export$3a89f8d6f6bf6c9f);
$parcel$export($8db1b5da822cad85$exports, "hermite", () => $8db1b5da822cad85$export$ae8865616f30561c);
$parcel$export($8db1b5da822cad85$exports, "bezier", () => $8db1b5da822cad85$export$b9c5f84610baddaf);
$parcel$export($8db1b5da822cad85$exports, "random", () => $8db1b5da822cad85$export$4385e60b38654f68);
$parcel$export($8db1b5da822cad85$exports, "transformMat4", () => $8db1b5da822cad85$export$5ffbd13800309d59);
$parcel$export($8db1b5da822cad85$exports, "transformMat3", () => $8db1b5da822cad85$export$f0bfa0a0024626ee);
$parcel$export($8db1b5da822cad85$exports, "transformQuat", () => $8db1b5da822cad85$export$c32adef9e939ce85);
$parcel$export($8db1b5da822cad85$exports, "rotateX", () => $8db1b5da822cad85$export$a59c8716592e09af);
$parcel$export($8db1b5da822cad85$exports, "rotateY", () => $8db1b5da822cad85$export$cf71e4d4ca4d1cfd);
$parcel$export($8db1b5da822cad85$exports, "rotateZ", () => $8db1b5da822cad85$export$ea6eae3365de5b9c);
$parcel$export($8db1b5da822cad85$exports, "angle", () => $8db1b5da822cad85$export$944b09d2ad10b378);
$parcel$export($8db1b5da822cad85$exports, "zero", () => $8db1b5da822cad85$export$7f9972325ebfd559);
$parcel$export($8db1b5da822cad85$exports, "str", () => $8db1b5da822cad85$export$42d51816ce590c93);
$parcel$export($8db1b5da822cad85$exports, "exactEquals", () => $8db1b5da822cad85$export$f2599a5cf1109d8);
$parcel$export($8db1b5da822cad85$exports, "equals", () => $8db1b5da822cad85$export$e9bab7fafb253603);
$parcel$export($8db1b5da822cad85$exports, "sub", () => $8db1b5da822cad85$export$f93b5905241a7cca);
$parcel$export($8db1b5da822cad85$exports, "mul", () => $8db1b5da822cad85$export$6e3a27864ab166fe);
$parcel$export($8db1b5da822cad85$exports, "div", () => $8db1b5da822cad85$export$159d9494db57879b);
$parcel$export($8db1b5da822cad85$exports, "dist", () => $8db1b5da822cad85$export$6c4a311cc157c764);
$parcel$export($8db1b5da822cad85$exports, "sqrDist", () => $8db1b5da822cad85$export$2422cd6c492a8b3a);
$parcel$export($8db1b5da822cad85$exports, "len", () => $8db1b5da822cad85$export$fc1400facf92c78);
$parcel$export($8db1b5da822cad85$exports, "sqrLen", () => $8db1b5da822cad85$export$99d8dd3f32a3435);
$parcel$export($8db1b5da822cad85$exports, "forEach", () => $8db1b5da822cad85$export$4b80e395e36b5a56);

function $8db1b5da822cad85$export$185802fd694ee1f5() {
    var out = new $025278b023032180$export$b67359430d3b1b2(3);
    if ($025278b023032180$export$b67359430d3b1b2 != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
    }
    return out;
}
function $8db1b5da822cad85$export$9cd59f9826255e47(a) {
    var out = new $025278b023032180$export$b67359430d3b1b2(3);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function $8db1b5da822cad85$export$f24224f1c91d8156(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    return Math.hypot(x, y, z);
}
function $8db1b5da822cad85$export$a82be99ed2a44a7d(x, y, z) {
    var out = new $025278b023032180$export$b67359430d3b1b2(3);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function $8db1b5da822cad85$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function $8db1b5da822cad85$export$adaa4cf7ef1b65be(out, x, y, z) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function $8db1b5da822cad85$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    return out;
}
function $8db1b5da822cad85$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    return out;
}
function $8db1b5da822cad85$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    return out;
}
function $8db1b5da822cad85$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    return out;
}
function $8db1b5da822cad85$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    return out;
}
function $8db1b5da822cad85$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    return out;
}
function $8db1b5da822cad85$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    return out;
}
function $8db1b5da822cad85$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    return out;
}
function $8db1b5da822cad85$export$2077e0241d6afd3c(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    out[2] = Math.round(a[2]);
    return out;
}
function $8db1b5da822cad85$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    return out;
}
function $8db1b5da822cad85$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    return out;
}
function $8db1b5da822cad85$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    return Math.hypot(x, y, z);
}
function $8db1b5da822cad85$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    return x * x + y * y + z * z;
}
function $8db1b5da822cad85$export$ab44e1323ffc8376(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    return x * x + y * y + z * z;
}
function $8db1b5da822cad85$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    return out;
}
function $8db1b5da822cad85$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    return out;
}
function $8db1b5da822cad85$export$a3295358bff77e(out, a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var len = x * x + y * y + z * z;
    if (len > 0) //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    out[2] = a[2] * len;
    return out;
}
function $8db1b5da822cad85$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $8db1b5da822cad85$export$bb646b20bb93d339(out, a, b) {
    var ax = a[0], ay = a[1], az = a[2];
    var bx = b[0], by = b[1], bz = b[2];
    out[0] = ay * bz - az * by;
    out[1] = az * bx - ax * bz;
    out[2] = ax * by - ay * bx;
    return out;
}
function $8db1b5da822cad85$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    return out;
}
function $8db1b5da822cad85$export$ae8865616f30561c(out, a, b, c, d, t) {
    var factorTimes2 = t * t;
    var factor1 = factorTimes2 * (2 * t - 3) + 1;
    var factor2 = factorTimes2 * (t - 2) + t;
    var factor3 = factorTimes2 * (t - 1);
    var factor4 = factorTimes2 * (3 - 2 * t);
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
function $8db1b5da822cad85$export$b9c5f84610baddaf(out, a, b, c, d, t) {
    var inverseFactor = 1 - t;
    var inverseFactorTimesTwo = inverseFactor * inverseFactor;
    var factorTimes2 = t * t;
    var factor1 = inverseFactorTimesTwo * inverseFactor;
    var factor2 = 3 * t * inverseFactorTimesTwo;
    var factor3 = 3 * factorTimes2 * inverseFactor;
    var factor4 = factorTimes2 * t;
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
function $8db1b5da822cad85$export$4385e60b38654f68(out, scale) {
    scale = scale || 1.0;
    var r = $025278b023032180$export$5ada478c8a628231() * 2.0 * Math.PI;
    var z = $025278b023032180$export$5ada478c8a628231() * 2.0 - 1.0;
    var zScale = Math.sqrt(1.0 - z * z) * scale;
    out[0] = Math.cos(r) * zScale;
    out[1] = Math.sin(r) * zScale;
    out[2] = z * scale;
    return out;
}
function $8db1b5da822cad85$export$5ffbd13800309d59(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    var w = m[3] * x + m[7] * y + m[11] * z + m[15];
    w = w || 1.0;
    out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
    out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
    out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
    return out;
}
function $8db1b5da822cad85$export$f0bfa0a0024626ee(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    out[0] = x * m[0] + y * m[3] + z * m[6];
    out[1] = x * m[1] + y * m[4] + z * m[7];
    out[2] = x * m[2] + y * m[5] + z * m[8];
    return out;
}
function $8db1b5da822cad85$export$c32adef9e939ce85(out, a, q) {
    // benchmarks: https://jsperf.com/quaternion-transform-vec3-implementations-fixed
    var qx = q[0], qy = q[1], qz = q[2], qw = q[3];
    var x = a[0], y = a[1], z = a[2]; // var qvec = [qx, qy, qz];
    // var uv = vec3.cross([], qvec, a);
    var uvx = qy * z - qz * y, uvy = qz * x - qx * z, uvz = qx * y - qy * x; // var uuv = vec3.cross([], qvec, uv);
    var uuvx = qy * uvz - qz * uvy, uuvy = qz * uvx - qx * uvz, uuvz = qx * uvy - qy * uvx; // vec3.scale(uv, uv, 2 * w);
    var w2 = qw * 2;
    uvx *= w2;
    uvy *= w2;
    uvz *= w2; // vec3.scale(uuv, uuv, 2);
    uuvx *= 2;
    uuvy *= 2;
    uuvz *= 2; // return vec3.add(out, a, vec3.add(out, uv, uuv));
    out[0] = x + uvx + uuvx;
    out[1] = y + uvy + uuvy;
    out[2] = z + uvz + uuvz;
    return out;
}
function $8db1b5da822cad85$export$a59c8716592e09af(out, a, b, rad) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[0];
    r[1] = p[1] * Math.cos(rad) - p[2] * Math.sin(rad);
    r[2] = p[1] * Math.sin(rad) + p[2] * Math.cos(rad); //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $8db1b5da822cad85$export$cf71e4d4ca4d1cfd(out, a, b, rad) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[2] * Math.sin(rad) + p[0] * Math.cos(rad);
    r[1] = p[1];
    r[2] = p[2] * Math.cos(rad) - p[0] * Math.sin(rad); //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $8db1b5da822cad85$export$ea6eae3365de5b9c(out, a, b, rad) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[0] * Math.cos(rad) - p[1] * Math.sin(rad);
    r[1] = p[0] * Math.sin(rad) + p[1] * Math.cos(rad);
    r[2] = p[2]; //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $8db1b5da822cad85$export$944b09d2ad10b378(a, b) {
    var ax = a[0], ay = a[1], az = a[2], bx = b[0], by = b[1], bz = b[2], mag1 = Math.sqrt(ax * ax + ay * ay + az * az), mag2 = Math.sqrt(bx * bx + by * by + bz * bz), mag = mag1 * mag2, cosine = mag && $8db1b5da822cad85$export$94132a0e348806d4(a, b) / mag;
    return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
function $8db1b5da822cad85$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    out[2] = 0.0;
    return out;
}
function $8db1b5da822cad85$export$42d51816ce590c93(a) {
    return "vec3(" + a[0] + ", " + a[1] + ", " + a[2] + ")";
}
function $8db1b5da822cad85$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
}
function $8db1b5da822cad85$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2];
    var b0 = b[0], b1 = b[1], b2 = b[2];
    return Math.abs(a0 - b0) <= $025278b023032180$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $025278b023032180$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $025278b023032180$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a2), Math.abs(b2));
}
var $8db1b5da822cad85$export$f93b5905241a7cca = $8db1b5da822cad85$export$4e2d2ead65e5f7e3;
var $8db1b5da822cad85$export$6e3a27864ab166fe = $8db1b5da822cad85$export$2060d2db72cce88f;
var $8db1b5da822cad85$export$159d9494db57879b = $8db1b5da822cad85$export$cd007d971a5a2143;
var $8db1b5da822cad85$export$6c4a311cc157c764 = $8db1b5da822cad85$export$9f17032d917177de;
var $8db1b5da822cad85$export$2422cd6c492a8b3a = $8db1b5da822cad85$export$88e6ebb4fe54f538;
var $8db1b5da822cad85$export$fc1400facf92c78 = $8db1b5da822cad85$export$f24224f1c91d8156;
var $8db1b5da822cad85$export$99d8dd3f32a3435 = $8db1b5da822cad85$export$ab44e1323ffc8376;
var $8db1b5da822cad85$export$4b80e395e36b5a56 = function() {
    var vec = $8db1b5da822cad85$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 3;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
        }
        return a;
    };
}();


var $587dd1aab7f85c46$exports = {};

$parcel$export($587dd1aab7f85c46$exports, "create", () => $587dd1aab7f85c46$export$185802fd694ee1f5);
$parcel$export($587dd1aab7f85c46$exports, "clone", () => $587dd1aab7f85c46$export$9cd59f9826255e47);
$parcel$export($587dd1aab7f85c46$exports, "fromValues", () => $587dd1aab7f85c46$export$a82be99ed2a44a7d);
$parcel$export($587dd1aab7f85c46$exports, "copy", () => $587dd1aab7f85c46$export$784d13d8ee351f07);
$parcel$export($587dd1aab7f85c46$exports, "set", () => $587dd1aab7f85c46$export$adaa4cf7ef1b65be);
$parcel$export($587dd1aab7f85c46$exports, "add", () => $587dd1aab7f85c46$export$e16d8520af44a096);
$parcel$export($587dd1aab7f85c46$exports, "subtract", () => $587dd1aab7f85c46$export$4e2d2ead65e5f7e3);
$parcel$export($587dd1aab7f85c46$exports, "multiply", () => $587dd1aab7f85c46$export$2060d2db72cce88f);
$parcel$export($587dd1aab7f85c46$exports, "divide", () => $587dd1aab7f85c46$export$cd007d971a5a2143);
$parcel$export($587dd1aab7f85c46$exports, "ceil", () => $587dd1aab7f85c46$export$803ce6b71a0a94b2);
$parcel$export($587dd1aab7f85c46$exports, "floor", () => $587dd1aab7f85c46$export$a3fe094919f356fd);
$parcel$export($587dd1aab7f85c46$exports, "min", () => $587dd1aab7f85c46$export$96ec731ed4dcb222);
$parcel$export($587dd1aab7f85c46$exports, "max", () => $587dd1aab7f85c46$export$8960430cfd85939f);
$parcel$export($587dd1aab7f85c46$exports, "round", () => $587dd1aab7f85c46$export$2077e0241d6afd3c);
$parcel$export($587dd1aab7f85c46$exports, "scale", () => $587dd1aab7f85c46$export$dcdf75081b88279d);
$parcel$export($587dd1aab7f85c46$exports, "scaleAndAdd", () => $587dd1aab7f85c46$export$19cedf1da84ba854);
$parcel$export($587dd1aab7f85c46$exports, "distance", () => $587dd1aab7f85c46$export$9f17032d917177de);
$parcel$export($587dd1aab7f85c46$exports, "squaredDistance", () => $587dd1aab7f85c46$export$88e6ebb4fe54f538);
$parcel$export($587dd1aab7f85c46$exports, "length", () => $587dd1aab7f85c46$export$f24224f1c91d8156);
$parcel$export($587dd1aab7f85c46$exports, "squaredLength", () => $587dd1aab7f85c46$export$ab44e1323ffc8376);
$parcel$export($587dd1aab7f85c46$exports, "negate", () => $587dd1aab7f85c46$export$aef51622e549b8b0);
$parcel$export($587dd1aab7f85c46$exports, "inverse", () => $587dd1aab7f85c46$export$70ae2c07e401031b);
$parcel$export($587dd1aab7f85c46$exports, "normalize", () => $587dd1aab7f85c46$export$a3295358bff77e);
$parcel$export($587dd1aab7f85c46$exports, "dot", () => $587dd1aab7f85c46$export$94132a0e348806d4);
$parcel$export($587dd1aab7f85c46$exports, "cross", () => $587dd1aab7f85c46$export$bb646b20bb93d339);
$parcel$export($587dd1aab7f85c46$exports, "lerp", () => $587dd1aab7f85c46$export$3a89f8d6f6bf6c9f);
$parcel$export($587dd1aab7f85c46$exports, "random", () => $587dd1aab7f85c46$export$4385e60b38654f68);
$parcel$export($587dd1aab7f85c46$exports, "transformMat2", () => $587dd1aab7f85c46$export$b732428d73874bfc);
$parcel$export($587dd1aab7f85c46$exports, "transformMat2d", () => $587dd1aab7f85c46$export$3e55bc4b3707dfd3);
$parcel$export($587dd1aab7f85c46$exports, "transformMat3", () => $587dd1aab7f85c46$export$f0bfa0a0024626ee);
$parcel$export($587dd1aab7f85c46$exports, "transformMat4", () => $587dd1aab7f85c46$export$5ffbd13800309d59);
$parcel$export($587dd1aab7f85c46$exports, "rotate", () => $587dd1aab7f85c46$export$bb628a54ab399bc9);
$parcel$export($587dd1aab7f85c46$exports, "angle", () => $587dd1aab7f85c46$export$944b09d2ad10b378);
$parcel$export($587dd1aab7f85c46$exports, "zero", () => $587dd1aab7f85c46$export$7f9972325ebfd559);
$parcel$export($587dd1aab7f85c46$exports, "str", () => $587dd1aab7f85c46$export$42d51816ce590c93);
$parcel$export($587dd1aab7f85c46$exports, "exactEquals", () => $587dd1aab7f85c46$export$f2599a5cf1109d8);
$parcel$export($587dd1aab7f85c46$exports, "equals", () => $587dd1aab7f85c46$export$e9bab7fafb253603);
$parcel$export($587dd1aab7f85c46$exports, "len", () => $587dd1aab7f85c46$export$fc1400facf92c78);
$parcel$export($587dd1aab7f85c46$exports, "sub", () => $587dd1aab7f85c46$export$f93b5905241a7cca);
$parcel$export($587dd1aab7f85c46$exports, "mul", () => $587dd1aab7f85c46$export$6e3a27864ab166fe);
$parcel$export($587dd1aab7f85c46$exports, "div", () => $587dd1aab7f85c46$export$159d9494db57879b);
$parcel$export($587dd1aab7f85c46$exports, "dist", () => $587dd1aab7f85c46$export$6c4a311cc157c764);
$parcel$export($587dd1aab7f85c46$exports, "sqrDist", () => $587dd1aab7f85c46$export$2422cd6c492a8b3a);
$parcel$export($587dd1aab7f85c46$exports, "sqrLen", () => $587dd1aab7f85c46$export$99d8dd3f32a3435);
$parcel$export($587dd1aab7f85c46$exports, "forEach", () => $587dd1aab7f85c46$export$4b80e395e36b5a56);

function $587dd1aab7f85c46$export$185802fd694ee1f5() {
    var out = new $025278b023032180$export$b67359430d3b1b2(2);
    if ($025278b023032180$export$b67359430d3b1b2 != Float32Array) {
        out[0] = 0;
        out[1] = 0;
    }
    return out;
}
function $587dd1aab7f85c46$export$9cd59f9826255e47(a) {
    var out = new $025278b023032180$export$b67359430d3b1b2(2);
    out[0] = a[0];
    out[1] = a[1];
    return out;
}
function $587dd1aab7f85c46$export$a82be99ed2a44a7d(x, y) {
    var out = new $025278b023032180$export$b67359430d3b1b2(2);
    out[0] = x;
    out[1] = y;
    return out;
}
function $587dd1aab7f85c46$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    return out;
}
function $587dd1aab7f85c46$export$adaa4cf7ef1b65be(out, x, y) {
    out[0] = x;
    out[1] = y;
    return out;
}
function $587dd1aab7f85c46$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    return out;
}
function $587dd1aab7f85c46$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    return out;
}
function $587dd1aab7f85c46$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    return out;
}
function $587dd1aab7f85c46$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    return out;
}
function $587dd1aab7f85c46$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    return out;
}
function $587dd1aab7f85c46$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    return out;
}
function $587dd1aab7f85c46$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    return out;
}
function $587dd1aab7f85c46$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    return out;
}
function $587dd1aab7f85c46$export$2077e0241d6afd3c(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    return out;
}
function $587dd1aab7f85c46$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    return out;
}
function $587dd1aab7f85c46$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    return out;
}
function $587dd1aab7f85c46$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return Math.hypot(x, y);
}
function $587dd1aab7f85c46$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return x * x + y * y;
}
function $587dd1aab7f85c46$export$f24224f1c91d8156(a) {
    var x = a[0], y = a[1];
    return Math.hypot(x, y);
}
function $587dd1aab7f85c46$export$ab44e1323ffc8376(a) {
    var x = a[0], y = a[1];
    return x * x + y * y;
}
function $587dd1aab7f85c46$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    return out;
}
function $587dd1aab7f85c46$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    return out;
}
function $587dd1aab7f85c46$export$a3295358bff77e(out, a) {
    var x = a[0], y = a[1];
    var len = x * x + y * y;
    if (len > 0) //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    return out;
}
function $587dd1aab7f85c46$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1];
}
function $587dd1aab7f85c46$export$bb646b20bb93d339(out, a, b) {
    var z = a[0] * b[1] - a[1] * b[0];
    out[0] = out[1] = 0;
    out[2] = z;
    return out;
}
function $587dd1aab7f85c46$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0], ay = a[1];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    return out;
}
function $587dd1aab7f85c46$export$4385e60b38654f68(out, scale) {
    scale = scale || 1.0;
    var r = $025278b023032180$export$5ada478c8a628231() * 2.0 * Math.PI;
    out[0] = Math.cos(r) * scale;
    out[1] = Math.sin(r) * scale;
    return out;
}
function $587dd1aab7f85c46$export$b732428d73874bfc(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y;
    out[1] = m[1] * x + m[3] * y;
    return out;
}
function $587dd1aab7f85c46$export$3e55bc4b3707dfd3(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
function $587dd1aab7f85c46$export$f0bfa0a0024626ee(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[3] * y + m[6];
    out[1] = m[1] * x + m[4] * y + m[7];
    return out;
}
function $587dd1aab7f85c46$export$5ffbd13800309d59(out, a, m) {
    var x = a[0];
    var y = a[1];
    out[0] = m[0] * x + m[4] * y + m[12];
    out[1] = m[1] * x + m[5] * y + m[13];
    return out;
}
function $587dd1aab7f85c46$export$bb628a54ab399bc9(out, a, b, rad) {
    //Translate point to the origin
    var p0 = a[0] - b[0], p1 = a[1] - b[1], sinC = Math.sin(rad), cosC = Math.cos(rad); //perform rotation and translate to correct position
    out[0] = p0 * cosC - p1 * sinC + b[0];
    out[1] = p0 * sinC + p1 * cosC + b[1];
    return out;
}
function $587dd1aab7f85c46$export$944b09d2ad10b378(a, b) {
    var x1 = a[0], y1 = a[1], x2 = b[0], y2 = b[1], // mag is the product of the magnitudes of a and b
    mag = Math.sqrt(x1 * x1 + y1 * y1) * Math.sqrt(x2 * x2 + y2 * y2), // mag &&.. short circuits if mag == 0
    cosine = mag && (x1 * x2 + y1 * y2) / mag; // Math.min(Math.max(cosine, -1), 1) clamps the cosine between -1 and 1
    return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
function $587dd1aab7f85c46$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    return out;
}
function $587dd1aab7f85c46$export$42d51816ce590c93(a) {
    return "vec2(" + a[0] + ", " + a[1] + ")";
}
function $587dd1aab7f85c46$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1];
}
function $587dd1aab7f85c46$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1];
    var b0 = b[0], b1 = b[1];
    return Math.abs(a0 - b0) <= $025278b023032180$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $025278b023032180$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a1), Math.abs(b1));
}
var $587dd1aab7f85c46$export$fc1400facf92c78 = $587dd1aab7f85c46$export$f24224f1c91d8156;
var $587dd1aab7f85c46$export$f93b5905241a7cca = $587dd1aab7f85c46$export$4e2d2ead65e5f7e3;
var $587dd1aab7f85c46$export$6e3a27864ab166fe = $587dd1aab7f85c46$export$2060d2db72cce88f;
var $587dd1aab7f85c46$export$159d9494db57879b = $587dd1aab7f85c46$export$cd007d971a5a2143;
var $587dd1aab7f85c46$export$6c4a311cc157c764 = $587dd1aab7f85c46$export$9f17032d917177de;
var $587dd1aab7f85c46$export$2422cd6c492a8b3a = $587dd1aab7f85c46$export$88e6ebb4fe54f538;
var $587dd1aab7f85c46$export$99d8dd3f32a3435 = $587dd1aab7f85c46$export$ab44e1323ffc8376;
var $587dd1aab7f85c46$export$4b80e395e36b5a56 = function() {
    var vec = $587dd1aab7f85c46$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 2;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
        }
        return a;
    };
}();


var $2d8bc665070e6403$export$d630b5401a6a2fc8;
(function(DebugDrawFlags) {
    DebugDrawFlags[DebugDrawFlags["WorldSpace"] = 0] = "WorldSpace";
    DebugDrawFlags[DebugDrawFlags["ViewSpace"] = 1] = "ViewSpace";
    DebugDrawFlags[DebugDrawFlags["ScreenSpace"] = 2] = "ScreenSpace";
    DebugDrawFlags[DebugDrawFlags["DepthTint"] = 4] = "DepthTint";
    DebugDrawFlags[DebugDrawFlags["Default"] = 4] = "Default";
})($2d8bc665070e6403$export$d630b5401a6a2fc8 || ($2d8bc665070e6403$export$d630b5401a6a2fc8 = {}));
const $2d8bc665070e6403$var$SpaceMask = 3;
function $2d8bc665070e6403$var$align(n, multiple) {
    const mask = multiple - 1;
    return n + mask & ~mask;
}
function $2d8bc665070e6403$var$assert(b, message = "") {
    if (!b) {
        console.error(new Error().stack);
        throw new Error(`Assert fail: ${message}`);
    }
}
// https://jcgt.org/published/0006/01/01/
function $2d8bc665070e6403$var$branchlessONB(dstA, dstB, n) {
    const sign = n[2] >= 0.0 ? 1.0 : -1;
    const a = -1 / (sign + n[2]);
    const b = n[0] * n[1] * a;
    (0, $8db1b5da822cad85$exports).set(dstA, 1.0 + sign * n[0] * n[0] * a, sign * b, -sign * n[0]);
    (0, $8db1b5da822cad85$exports).set(dstB, b, sign + n[1] * n[1] * a, -n[1]);
}
const $2d8bc665070e6403$export$b7d7e6f1815ae490 = {
    r: 1,
    g: 0,
    b: 0,
    a: 1
};
const $2d8bc665070e6403$export$fcb7d257bdd6bd00 = {
    r: 0,
    g: 1,
    b: 0,
    a: 1
};
const $2d8bc665070e6403$export$c9cacf6069bed432 = {
    r: 0,
    g: 0,
    b: 1,
    a: 1
};
const $2d8bc665070e6403$export$e55adec373ccddbe = {
    r: 1,
    g: 1,
    b: 1,
    a: 1
};
const $2d8bc665070e6403$var$TAU = Math.PI * 2;
const $2d8bc665070e6403$var$Vec3UnitX = (0, $8db1b5da822cad85$exports).fromValues(1, 0, 0);
const $2d8bc665070e6403$var$Vec3UnitY = (0, $8db1b5da822cad85$exports).fromValues(0, 1, 0);
const $2d8bc665070e6403$var$Vec3UnitZ = (0, $8db1b5da822cad85$exports).fromValues(0, 0, 1);
function $2d8bc665070e6403$var$getMatrixAxisX(dst, m) {
    (0, $8db1b5da822cad85$exports).set(dst, m[0], m[1], m[2]);
}
function $2d8bc665070e6403$var$getMatrixAxisY(dst, m) {
    (0, $8db1b5da822cad85$exports).set(dst, m[4], m[5], m[6]);
}
function $2d8bc665070e6403$var$getMatrixAxisZ(dst, m) {
    (0, $8db1b5da822cad85$exports).set(dst, m[8], m[9], m[10]);
}
var $2d8bc665070e6403$var$BehaviorType;
(function(BehaviorType) {
    BehaviorType[BehaviorType["Lines"] = 0] = "Lines";
    BehaviorType[BehaviorType["LinesDepthWrite"] = 1] = "LinesDepthWrite";
    BehaviorType[BehaviorType["LinesDepthTint"] = 2] = "LinesDepthTint";
    BehaviorType[BehaviorType["Solid"] = 3] = "Solid";
    BehaviorType[BehaviorType["SolidDepthWrite"] = 4] = "SolidDepthWrite";
    BehaviorType[BehaviorType["SolidDepthTint"] = 5] = "SolidDepthTint";
    BehaviorType[BehaviorType["Font"] = 6] = "Font";
    BehaviorType[BehaviorType["Count"] = 7] = "Count";
})($2d8bc665070e6403$var$BehaviorType || ($2d8bc665070e6403$var$BehaviorType = {}));
function $2d8bc665070e6403$var$fillVec3p(d, offs, v) {
    d[offs + 0] = v[0];
    d[offs + 1] = v[1];
    d[offs + 2] = v[2];
    return 3;
}
function $2d8bc665070e6403$var$fillColor(d, offs, c, a = c.a) {
    d[offs + 0] = c.r;
    d[offs + 1] = c.g;
    d[offs + 2] = c.b;
    d[offs + 3] = a;
    return 4;
}
class $2d8bc665070e6403$var$BufferPage {
    constructor(device, pso, behaviorType, vertexCount, indexCount){
        this.pso = pso;
        this.behaviorType = behaviorType;
        this.vertexDataOffs = 0;
        this.vertexStride = 7;
        this.indexDataOffs = 0;
        this.lifetime = 3;
        this.vertexData = new Float32Array(vertexCount * this.vertexStride);
        this.vertexBuffer = device.createBuffer({
            size: this.vertexData.byteLength,
            usage: GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST,
            label: `DebugDraw BufferPage Vertex`
        });
        this.indexData = new Uint16Array($2d8bc665070e6403$var$align(indexCount, 2));
        this.indexBuffer = device.createBuffer({
            size: this.indexData.byteLength,
            usage: GPUBufferUsage.INDEX | GPUBufferUsage.COPY_DST,
            label: `DebugDraw BufferPage Index`
        });
    }
    getCurrentVertexID() {
        return this.vertexDataOffs / this.vertexStride >>> 0;
    }
    remainVertex() {
        return this.vertexData.length - this.vertexDataOffs;
    }
    remainIndex() {
        return this.indexData.length - this.indexDataOffs;
    }
    getDrawCount() {
        return this.indexDataOffs;
    }
    canAllocVertices(vertexCount, indexCount) {
        return vertexCount * this.vertexStride <= this.remainVertex() && indexCount <= this.remainIndex();
    }
    vertexPCF(v, c, options) {
        this.vertexDataOffs += $2d8bc665070e6403$var$fillVec3p(this.vertexData, this.vertexDataOffs, v);
        const flags = options.flags;
        // encode flags in alpha
        const alpha = 1.0 - c.a + flags;
        this.vertexDataOffs += $2d8bc665070e6403$var$fillColor(this.vertexData, this.vertexDataOffs, c, alpha);
    }
    index(n) {
        this.indexData[this.indexDataOffs++] = n;
    }
    uploadData(device) {
        if (this.vertexDataOffs === 0) {
            if (--this.lifetime === 0) {
                this.destroy();
                return false;
            } else return true;
        }
        const queue = device.queue;
        queue.writeBuffer(this.vertexBuffer, 0, new Uint8Array(this.vertexData.buffer), 0, this.vertexDataOffs * 4);
        queue.writeBuffer(this.indexBuffer, 0, new Uint8Array(this.indexData.buffer), 0, this.indexDataOffs * 2);
        return true;
    }
    endFrame() {
        this.vertexDataOffs = 0;
        this.indexDataOffs = 0;
        this.lifetime = 3;
        return true;
    }
    destroy() {
        this.vertexBuffer.destroy();
        if (this.indexBuffer !== null) this.indexBuffer.destroy();
    }
}
class $2d8bc665070e6403$var$FontTexture {
    constructor(device){
        this.characters = "!\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~";
        this.font = `24px Consolas`;
        this.strokeWidth = 3;
        this.rasterize(device);
    }
    getCharacterIndex(c) {
        return this.characters.indexOf(c);
    }
    rasterize(device) {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        ctx.font = this.font;
        ctx.textAlign = `left`;
        ctx.textBaseline = `top`;
        let cellWidth = 0;
        let cellHeight = 0;
        for (const c of this.characters){
            const measure = ctx.measureText(c);
            const w = Math.ceil(measure.actualBoundingBoxRight + measure.actualBoundingBoxLeft);
            const h = Math.ceil(measure.actualBoundingBoxDescent + measure.actualBoundingBoxAscent);
            cellWidth = Math.max(cellWidth, w);
            cellHeight = Math.max(cellHeight, h);
        }
        this.advanceX = cellWidth;
        this.advanceY = cellHeight;
        // Padding
        const extra = this.strokeWidth * 0.5;
        cellWidth += extra * 2;
        cellHeight += extra * 2;
        canvas.width = cellWidth;
        canvas.height = cellHeight;
        this.gpuTexture = device.createTexture({
            size: [
                cellWidth,
                cellHeight,
                this.characters.length
            ],
            format: "r8unorm",
            usage: GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.RENDER_ATTACHMENT,
            label: `DebugFont`
        });
        ctx.font = this.font;
        ctx.textAlign = `left`;
        ctx.textBaseline = `top`;
        ctx.strokeStyle = `rgba(255, 255, 255, 0.5)`;
        ctx.lineWidth = this.strokeWidth;
        for(let i = 0; i < this.characters.length; i++){
            ctx.fillStyle = `black`;
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            const char = this.characters[i];
            ctx.fillStyle = `rgba(255, 255, 255, 1.0)`;
            ctx.strokeText(char, extra, extra);
            ctx.fillText(char, extra, extra);
            device.queue.copyExternalImageToTexture({
                source: canvas
            }, {
                texture: this.gpuTexture,
                origin: [
                    0,
                    0,
                    i
                ]
            }, canvas);
        }
    }
    destroy() {
        this.gpuTexture.destroy();
    }
}
class $2d8bc665070e6403$export$8c1f62922c980a1a {
    static{
        this.scratchVec3 = [
            (0, $8db1b5da822cad85$exports).create(),
            (0, $8db1b5da822cad85$exports).create(),
            (0, $8db1b5da822cad85$exports).create(),
            (0, $8db1b5da822cad85$exports).create()
        ];
    }
    constructor(device, colorTextureFormat){
        this.device = device;
        this.colorTextureFormat = colorTextureFormat;
        this.pages = [];
        this.defaultPageVertexCount = 1024;
        this.defaultPageIndexCount = 1024;
        this.currentPage = null;
        this.pso = [];
        this.lineThickness = 3;
        this.screenWidth = 1;
        this.screenHeight = 1;
        this.screenPrintPos = (0, $587dd1aab7f85c46$exports).create();
        this.shaderModule = this.createShaderModule();
        this.uniformBuffer = device.createBuffer({
            usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST,
            size: 144,
            label: `DebugDraw Uniforms`
        });
        this.bindGroupLayout = device.createBindGroupLayout({
            entries: [
                {
                    binding: 0,
                    visibility: GPUShaderStage.VERTEX | GPUShaderStage.FRAGMENT,
                    buffer: {
                        type: "uniform"
                    }
                },
                {
                    binding: 1,
                    visibility: GPUShaderStage.FRAGMENT,
                    texture: {
                        viewDimension: "2d-array"
                    }
                },
                {
                    binding: 2,
                    visibility: GPUShaderStage.FRAGMENT,
                    sampler: {}
                },
                {
                    binding: 3,
                    visibility: GPUShaderStage.VERTEX | GPUShaderStage.FRAGMENT,
                    texture: {
                        sampleType: "depth"
                    }
                }
            ],
            label: "DebugDraw"
        });
        this.pipelineLayout = device.createPipelineLayout({
            bindGroupLayouts: [
                this.bindGroupLayout
            ],
            label: "DebugDraw"
        });
        for(let i = 0; i < 7; i++)this.pso[i] = this.createPipeline(i);
        this.dummyDepthBuffer = device.createTexture({
            format: "depth24plus",
            size: [
                1,
                1
            ],
            usage: GPUTextureUsage.TEXTURE_BINDING
        });
        this.fontTexture = new $2d8bc665070e6403$var$FontTexture(this.device);
        this.debugDrawGPU = new $2d8bc665070e6403$var$DebugDrawGPU(this, this.device);
        this.fontSampler = device.createSampler({
            addressModeU: `clamp-to-edge`,
            addressModeV: `clamp-to-edge`,
            minFilter: `linear`,
            magFilter: `linear`,
            label: `DebugDraw Font`
        });
    }
    getGPUBuffer() {
        return this.debugDrawGPU.gpuBuffer;
    }
    createShaderModule() {
        const code = `
struct ViewData {
    clip_from_view: mat4x4f,
    view_from_world: mat4x4f,
    misc: vec4f, // screen_size_inv
};

@id(0) override behavior_type: u32 = ${1};

@group(0) @binding(0) var<uniform> view_data: ViewData;
@group(0) @binding(1) var font_texture: texture_2d_array<f32>;
@group(0) @binding(2) var font_sampler: sampler;
@group(0) @binding(3) var depth_buffer: texture_depth_2d;

struct VertexOutput {
    @builtin(position) position: vec4f,
    @location(0) color: vec4f,
    @location(1) uv: vec3f,
    @location(2) @interpolate(flat, either) flags: u32,
};

@vertex
fn main_vs(@location(0) position: vec3f, @location(1) color_: vec4f, @builtin(vertex_index) vertex_index: u32, @builtin(instance_index) instance_index: u32) -> VertexOutput {
    var out: VertexOutput;

    // Flags are packed in the integer component of the alpha.
    var color = color_;
    var flags = u32(color.a);

    var space = flags & ${$2d8bc665070e6403$var$SpaceMask};
    if (space == ${0}) {
        out.position = view_data.clip_from_view * view_data.view_from_world * vec4f(position, 1.0f);
    } else if (space == ${1}) {
        out.position = view_data.clip_from_view * vec4f(position, 1.0f);
    } else if (space == ${2}) {
        out.position = vec4f(position.xy, 0.1f, 1.0f);
    }

    if (behavior_type == ${6}) {
        // Encoding for font characters is a bit silly. The color takes the range 0.0f - 1.0f,
        //   index 0 has the range [0.0f, 1.0f]
        //   index 1 has the range [2.0f, 3.0f]
        var base = i32(color.r);
        var font_character_index = base / 2;

        color.r = color.r - f32(font_character_index * 2);

        var quad_vertex = vertex_index & 3;
        out.uv.x = select(0.0f, 1.0f, (quad_vertex == 1 || quad_vertex == 2));
        out.uv.y = select(0.0f, 1.0f, (quad_vertex == 2 || quad_vertex == 3));
        out.uv.z = f32(font_character_index);
    }

    if (behavior_type == ${0} || behavior_type == ${2} || behavior_type == ${1}) {
        // Hacky thick line support.
        if (instance_index >= 1) {
            var line_idx = instance_index - 1;
            var offs: vec2f;
            offs.x = select(1.0f, -1.0f, (line_idx & 1u) != 0u);
            offs.y = select(1.0f, -1.0f, (line_idx & 2u) != 0u);
            offs *= f32((line_idx / 4) + 1);

            var inv_screen_size = view_data.misc.xy;
            out.position += vec4f(offs * inv_screen_size, 0.0f, 0.0f) * out.position.w;
        }
    }

    out.flags = flags;
    var alpha = 1.0f - fract(color.a);
    out.color = vec4f(color.rgb * alpha, alpha);
    return out;
}

@fragment
fn main_ps(vertex: VertexOutput) -> @location(0) vec4f {
    var color = vertex.color;

    if (behavior_type == ${6}) {
        var coverage = textureSample(font_texture, font_sampler, vertex.uv.xy, i32(vertex.uv.z)).r;
        // Map range 0.0f - 0.5f to outline color (solid black), and 0.5f to 1.0f range to color.
        var transparent = vec4f(0.0f, 0.0f, 0.0f, 0.0f);
        var outline_color = vec4f(0.0f, 0.0f, 0.0f, 1.0f);
        if (coverage > 0.5f) {
            color = mix(outline_color, color, ((coverage - 0.5f) * 2.0f));
        } else {
            color = mix(transparent, outline_color, coverage * 2.0f);
        }
    }

    if (behavior_type == ${2} || behavior_type == ${5}) {
        // Do manual depth testing so we can do a depth tint.
        var depth = textureLoad(depth_buffer, vec2u(vertex.position.xy), 0);

        if (depth > vertex.position.z) {
            color *= 0.15f;
        }
    }

    return color;
}
`;
        return this.device.createShaderModule({
            code: code,
            label: `DebugDraw`
        });
    }
    createPipeline(behaviorType) {
        // Create the PSO based on our state.
        const isLines = behaviorType === 1 || behaviorType === 2;
        const isDepthWrite = behaviorType === 1 || behaviorType === 4;
        const isDepthTint = behaviorType === 2 || behaviorType === 5;
        const desc = {
            layout: this.pipelineLayout,
            primitive: {
                topology: isLines ? "line-list" : "triangle-list"
            },
            vertex: {
                module: this.shaderModule,
                constants: {
                    0: behaviorType
                },
                entryPoint: "main_vs",
                buffers: [
                    {
                        attributes: [
                            {
                                shaderLocation: 0,
                                format: "float32x3",
                                offset: 0
                            },
                            {
                                shaderLocation: 1,
                                format: "float32x4",
                                offset: 12
                            }
                        ],
                        arrayStride: 28
                    }
                ]
            },
            fragment: {
                module: this.shaderModule,
                constants: {
                    0: behaviorType
                },
                entryPoint: "main_ps",
                targets: [
                    {
                        format: this.colorTextureFormat,
                        blend: {
                            color: {
                                operation: "add",
                                srcFactor: "one",
                                dstFactor: "one-minus-src-alpha"
                            },
                            alpha: {
                                operation: "add",
                                srcFactor: "one",
                                dstFactor: "one-minus-src-alpha"
                            }
                        }
                    }
                ]
            },
            depthStencil: isDepthTint ? undefined : {
                format: "depth24plus",
                depthCompare: "greater",
                depthWriteEnabled: isDepthWrite
            },
            label: `DebugDraw ${$2d8bc665070e6403$var$BehaviorType[behaviorType]}`
        };
        return this.device.createRenderPipeline(desc);
    }
    getBehaviorType(isLines, isOpaque, options) {
        const isDepthTint = options.flags & 4;
        if (isLines) return isDepthTint ? 2 : isOpaque ? 1 : 0;
        else return isDepthTint ? 5 : isOpaque ? 4 : 0;
    }
    beginBatch(behaviorType, vertexCount, indexCount) {
        this.currentPage = this.findPage(behaviorType, vertexCount, indexCount);
    }
    beginBatchLine(numSegments, color, options = {
        flags: 4
    }) {
        const behaviorType = this.getBehaviorType(true, color.a >= 1.0, options);
        this.beginBatch(behaviorType, numSegments * 2, numSegments * 2);
    }
    endBatch() {
        $2d8bc665070e6403$var$assert(this.currentPage !== null);
        this.currentPage = null;
    }
    findPage(behaviorType, vertexCount, indexCount) {
        if (this.currentPage !== null) {
            $2d8bc665070e6403$var$assert(this.currentPage.behaviorType === behaviorType);
            $2d8bc665070e6403$var$assert(this.currentPage.canAllocVertices(vertexCount, indexCount));
            return this.currentPage;
        }
        for(let i = 0; i < this.pages.length; i++){
            const page = this.pages[i];
            if (page.behaviorType === behaviorType && page.canAllocVertices(vertexCount, indexCount)) return page;
        }
        vertexCount = $2d8bc665070e6403$var$align(vertexCount, this.defaultPageVertexCount);
        indexCount = $2d8bc665070e6403$var$align(indexCount, this.defaultPageIndexCount);
        const page = new $2d8bc665070e6403$var$BufferPage(this.device, this.pso[behaviorType], behaviorType, vertexCount, indexCount);
        this.pages.push(page);
        return page;
    }
    drawLine(p0, p1, color0, color1 = color0, options = {
        flags: 4
    }) {
        const page = this.findPage(this.getBehaviorType(true, color0.a >= 1.0 && color1.a >= 1.0, options), 2, 2);
        const baseVertex = page.getCurrentVertexID();
        page.vertexPCF(p0, color0, options);
        page.vertexPCF(p1, color1, options);
        for(let i = 0; i < 2; i++)page.index(baseVertex + i);
    }
    drawVector(p0, dir, mag, color0, color1 = color0, options = {
        flags: 4
    }) {
        (0, $8db1b5da822cad85$exports).scaleAndAdd($2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[0], p0, dir, mag);
        this.drawLine(p0, $2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[0], color0, color1, options);
    }
    drawBasis(m, mag = 100, options = {
        flags: 4
    }) {
        const page = this.findPage(this.getBehaviorType(true, true, options), 6, 6);
        const baseVertex = page.getCurrentVertexID();
        (0, $90bfe889a3a444a8$exports).getTranslation($2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[0], m);
        // X
        $2d8bc665070e6403$var$getMatrixAxisX($2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[1], m);
        (0, $8db1b5da822cad85$exports).scaleAndAdd($2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[1], $2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[0], $2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[1], mag);
        page.vertexPCF($2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[0], $2d8bc665070e6403$export$b7d7e6f1815ae490, options);
        page.vertexPCF($2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[1], $2d8bc665070e6403$export$b7d7e6f1815ae490, options);
        // Y
        $2d8bc665070e6403$var$getMatrixAxisY($2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[1], m);
        (0, $8db1b5da822cad85$exports).scaleAndAdd($2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[1], $2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[0], $2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[1], mag);
        page.vertexPCF($2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[0], $2d8bc665070e6403$export$fcb7d257bdd6bd00, options);
        page.vertexPCF($2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[1], $2d8bc665070e6403$export$fcb7d257bdd6bd00, options);
        // Z
        $2d8bc665070e6403$var$getMatrixAxisZ($2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[1], m);
        (0, $8db1b5da822cad85$exports).scaleAndAdd($2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[1], $2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[0], $2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[1], mag);
        page.vertexPCF($2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[0], $2d8bc665070e6403$export$c9cacf6069bed432, options);
        page.vertexPCF($2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[1], $2d8bc665070e6403$export$c9cacf6069bed432, options);
        for(let i = 0; i < 6; i++)page.index(baseVertex + i);
    }
    drawLocator(center, mag, color, options = {
        flags: 4
    }) {
        const page = this.findPage(this.getBehaviorType(true, color.a >= 1.0, options), 6, 6);
        const baseVertex = page.getCurrentVertexID();
        for(let i = 0; i < 3; i++){
            (0, $8db1b5da822cad85$exports).copy($2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[0], center);
            (0, $8db1b5da822cad85$exports).copy($2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[1], center);
            $2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[0][i] -= mag;
            $2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[1][i] += mag;
            page.vertexPCF($2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[0], color, options);
            page.vertexPCF($2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[1], color, options);
        }
        for(let i = 0; i < 6; i++)page.index(baseVertex + i);
    }
    drawDiscLineN(center, n, r, color, sides = 32, options = {
        flags: 4
    }) {
        $2d8bc665070e6403$var$branchlessONB($2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[0], $2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[1], n);
        this.drawDiscSolidRU(center, $2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[0], $2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[1], r, color, sides, options);
    }
    drawDiscLineRU(center, right, up, r, color, sides = 32, options = {
        flags: 4
    }) {
        const page = this.findPage(this.getBehaviorType(true, color.a >= 1.0, options), sides, sides * 2);
        const baseVertex = page.getCurrentVertexID();
        const s = $2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[2];
        for(let i = 0; i < sides; i++){
            const theta = i / sides * $2d8bc665070e6403$var$TAU;
            const sin = Math.sin(theta) * r, cos = Math.cos(theta) * r;
            s[0] = center[0] + right[0] * cos + up[0] * sin;
            s[1] = center[1] + right[1] * cos + up[1] * sin;
            s[2] = center[2] + right[2] * cos + up[2] * sin;
            page.vertexPCF(s, color, options);
            page.index(baseVertex + i);
            page.index(baseVertex + (i === sides - 1 ? 0 : i + 1));
        }
    }
    drawSphereLine(center, r, color, sides = 32, options = {
        flags: 4
    }) {
        this.drawDiscLineRU(center, $2d8bc665070e6403$var$Vec3UnitX, $2d8bc665070e6403$var$Vec3UnitY, r, color, sides, options);
        this.drawDiscLineRU(center, $2d8bc665070e6403$var$Vec3UnitX, $2d8bc665070e6403$var$Vec3UnitZ, r, color, sides, options);
        this.drawDiscLineRU(center, $2d8bc665070e6403$var$Vec3UnitY, $2d8bc665070e6403$var$Vec3UnitZ, r, color, sides, options);
    }
    drawDiscSolidN(center, n, r, color, sides = 32, options = {
        flags: 4
    }) {
        $2d8bc665070e6403$var$branchlessONB($2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[0], $2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[1], n);
        this.drawDiscSolidRU(center, $2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[0], $2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[1], r, color, sides, options);
    }
    drawDiscSolidRU(center, right, up, r, color, sides = 32, options = {
        flags: 4
    }) {
        const page = this.findPage(this.getBehaviorType(false, color.a >= 1.0, options), sides + 1, sides * 3);
        const baseVertex = page.getCurrentVertexID();
        page.vertexPCF(center, color, options);
        const s = $2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[2];
        for(let i = 0; i < sides - 1; i++){
            const theta = i / sides * $2d8bc665070e6403$var$TAU;
            const sin = Math.sin(theta) * r, cos = Math.cos(theta) * r;
            s[0] = center[0] + right[0] * cos + up[0] * sin;
            s[1] = center[1] + right[1] * cos + up[1] * sin;
            s[2] = center[2] + right[2] * cos + up[2] * sin;
            page.vertexPCF(s, color, options);
        }
        // construct trifans by hand
        for(let i = 0; i < sides - 2; i++){
            page.index(baseVertex);
            page.index(baseVertex + 1 + i);
            page.index(baseVertex + 2 + i);
        }
        page.index(baseVertex);
        page.index(baseVertex + sides - 1);
        page.index(baseVertex + 1);
    }
    rectCorner(dst, center, right, up, rightMag, upMag) {
        // TL, TR, BL, BR
        for(let i = 0; i < 4; i++){
            const signX = i & 1 ? -1 : 1;
            const signY = i & 2 ? -1 : 1;
            const s = dst[i];
            (0, $8db1b5da822cad85$exports).scaleAndAdd(s, center, right, signX * rightMag);
            (0, $8db1b5da822cad85$exports).scaleAndAdd(s, s, up, signY * upMag);
        }
    }
    drawTriSolidP(p0, p1, p2, color, options = {
        flags: 4
    }) {
        const page = this.findPage(this.getBehaviorType(false, color.a >= 1.0, options), 3, 3);
        const baseVertex = page.getCurrentVertexID();
        page.vertexPCF(p0, color, options);
        page.vertexPCF(p1, color, options);
        page.vertexPCF(p2, color, options);
        for(let i = 0; i < 3; i++)page.index(baseVertex + i);
    }
    drawRectLineP(p0, p1, p2, p3, color, options = {
        flags: 4
    }) {
        const page = this.findPage(this.getBehaviorType(true, color.a >= 1.0, options), 4, 8);
        const baseVertex = page.getCurrentVertexID();
        page.vertexPCF(p0, color, options);
        page.vertexPCF(p1, color, options);
        page.vertexPCF(p3, color, options);
        page.vertexPCF(p2, color, options);
        for(let i = 0; i < 4; i++){
            page.index(baseVertex + i);
            page.index(baseVertex + (i + 1 & 3));
        }
    }
    drawRectLineRU(center, right, up, rightMag, upMag, color, options = {
        flags: 4
    }) {
        this.rectCorner($2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3, center, right, up, rightMag, upMag);
        this.drawRectLineP($2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[0], $2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[1], $2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[2], $2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[3], color, options);
    }
    drawRectSolidP(p0, p1, p2, p3, color, options = {
        flags: 4
    }) {
        const page = this.findPage(this.getBehaviorType(false, color.a >= 1.0, options), 4, 6);
        const baseVertex = page.getCurrentVertexID();
        page.vertexPCF(p0, color, options);
        page.vertexPCF(p1, color, options);
        page.vertexPCF(p3, color, options);
        page.vertexPCF(p2, color, options);
        page.index(baseVertex + 0);
        page.index(baseVertex + 1);
        page.index(baseVertex + 2);
        page.index(baseVertex + 0);
        page.index(baseVertex + 2);
        page.index(baseVertex + 3);
    }
    drawRectSolidRU(center, right, up, rightMag, upMag, color, options = {
        flags: 4
    }) {
        this.rectCorner($2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3, center, right, up, rightMag, upMag);
        this.drawRectSolidP($2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[0], $2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[1], $2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[2], $2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[3], color, options);
    }
    // TODO(jstpierre): Clean this up and make it more generic.
    screenPrintText(s, size = 1, color = $2d8bc665070e6403$export$e55adec373ccddbe) {
        const numQuads = s.length;
        const page = this.findPage(6, numQuads * 4, numQuads * 6);
        const options = {
            flags: 2
        };
        let baseVertex = page.getCurrentVertexID();
        const advanceX = size * this.fontTexture.advanceX;
        const advanceY = size * this.fontTexture.advanceY;
        const sizeX = advanceX / this.screenWidth * 2;
        const sizeY = -advanceY / this.screenHeight * 2;
        const x = this.screenPrintPos[0] / this.screenWidth * 2 - 1;
        const y = this.screenPrintPos[1] / this.screenHeight * -2 + 1;
        const p = (0, $8db1b5da822cad85$exports).set($2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[0], x, y, 0.0);
        const colorR = color.r;
        const colorG = color.g;
        for(let i = 0; i < numQuads; i++){
            const char = s.charAt(i);
            if (char === "\n") {
                p[0] = x;
                p[1] += sizeY;
                this.screenPrintPos[1] += advanceY;
                continue;
            }
            const index = this.fontTexture.getCharacterIndex(char);
            if (index >= 0) {
                color.r = colorR + index * 2;
                // TL, TR, BR, BL
                page.vertexPCF(p, color, options);
                (0, $8db1b5da822cad85$exports).copy($2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[1], p);
                $2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[1][0] += sizeX;
                page.vertexPCF($2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[1], color, options);
                $2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[1][1] += sizeY;
                page.vertexPCF($2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[1], color, options);
                (0, $8db1b5da822cad85$exports).copy($2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[1], p);
                $2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[1][1] += sizeY;
                page.vertexPCF($2d8bc665070e6403$export$8c1f62922c980a1a.scratchVec3[1], color, options);
                page.index(baseVertex + 0);
                page.index(baseVertex + 1);
                page.index(baseVertex + 2);
                page.index(baseVertex + 0);
                page.index(baseVertex + 2);
                page.index(baseVertex + 3);
                baseVertex += 4;
            }
            p[0] += sizeX;
        }
        color.r = colorR;
        color.g = colorG;
        this.screenPrintPos[1] += advanceY;
    }
    uploadPages() {
        let types = 0;
        for(let i = 0; i < this.pages.length; i++){
            const page = this.pages[i];
            if (!page.uploadData(this.device)) this.pages.splice(i--, 1);
            types |= 1 << page.behaviorType;
        }
        return types;
    }
    drawPages(pass, behaviorTypes) {
        for(let i = 0; i < this.pages.length; i++){
            const page = this.pages[i];
            if (!(1 << page.behaviorType & behaviorTypes)) continue;
            const indexCount = page.getDrawCount();
            if (indexCount === 0) continue;
            pass.setPipeline(page.pso);
            pass.setVertexBuffer(0, page.vertexBuffer);
            pass.setIndexBuffer(page.indexBuffer, "uint16");
            const isLines = page.behaviorType === 1 || page.behaviorType === 2;
            const instanceCount = isLines ? 1 + (this.lineThickness - 1) * 4 : 1;
            pass.drawIndexed(indexCount, instanceCount);
            // Reset for next frame.
            page.endFrame();
        }
    }
    beginFrame(screenWidth, screenHeight, mouseX, mouseY, mouseButtons) {
        this.screenWidth = screenWidth;
        this.screenHeight = screenHeight;
        // Initialize to 10, 10
        (0, $587dd1aab7f85c46$exports).set(this.screenPrintPos, 10, 10);
        this.debugDrawGPU.beginFrame(mouseX, mouseY, mouseButtons);
    }
    endFrame(cmd, clipFromViewMatrix, viewFromWorldMatrix, colorTextureView, depthTextureView) {
        this.debugDrawGPU.endFrame(cmd);
        const behaviorTypes = this.uploadPages();
        if (behaviorTypes === 0) return;
        const data = new Float32Array(this.uniformBuffer.size / 4);
        data.set(clipFromViewMatrix, 0);
        data.set(viewFromWorldMatrix, 16);
        data[32] = 1 / this.screenWidth;
        data[33] = 1 / this.screenHeight;
        this.device.queue.writeBuffer(this.uniformBuffer, 0, data);
        // First, check if we have any solid stuff (needs proper depth).
        if (behaviorTypes & 91) {
            const bindGroup = this.device.createBindGroup({
                layout: this.bindGroupLayout,
                entries: [
                    {
                        binding: 0,
                        resource: {
                            buffer: this.uniformBuffer
                        }
                    },
                    {
                        binding: 1,
                        resource: this.fontTexture.gpuTexture.createView()
                    },
                    {
                        binding: 2,
                        resource: this.fontSampler
                    },
                    {
                        binding: 3,
                        resource: this.dummyDepthBuffer.createView()
                    }
                ],
                label: `DebugDraw DepthWrite`
            });
            const renderPass = cmd.beginRenderPass({
                colorAttachments: [
                    {
                        view: colorTextureView,
                        loadOp: "load",
                        storeOp: "store"
                    }
                ],
                depthStencilAttachment: {
                    view: depthTextureView,
                    depthLoadOp: "load",
                    depthStoreOp: "store"
                },
                label: `DebugDraw DepthTint`
            });
            renderPass.setBindGroup(0, bindGroup);
            this.drawPages(renderPass, 91);
            renderPass.end();
        }
        if (behaviorTypes & 36) {
            const bindGroup = this.device.createBindGroup({
                layout: this.bindGroupLayout,
                entries: [
                    {
                        binding: 0,
                        resource: {
                            buffer: this.uniformBuffer
                        }
                    },
                    {
                        binding: 1,
                        resource: this.fontTexture.gpuTexture.createView()
                    },
                    {
                        binding: 2,
                        resource: this.fontSampler
                    },
                    {
                        binding: 3,
                        resource: depthTextureView
                    }
                ],
                label: `DebugDraw DepthTint`
            });
            const renderPass = cmd.beginRenderPass({
                colorAttachments: [
                    {
                        view: colorTextureView,
                        loadOp: "load",
                        storeOp: "store"
                    }
                ],
                label: `DebugDraw DepthTint`
            });
            renderPass.setBindGroup(0, bindGroup);
            this.drawPages(renderPass, 36);
            renderPass.end();
        }
    }
    destroy() {
        for(let i = 0; i < this.pages.length; i++)this.pages[i].destroy();
    }
}
class $2d8bc665070e6403$var$DebugDrawGPU {
    constructor(debugDraw, device, size = 8196){
        this.debugDraw = debugDraw;
        this.device = device;
        this.size = size;
        this.framePool = [];
        this.submittedFrames = [];
        this.mouseHoverPos = (0, $587dd1aab7f85c46$exports).fromValues(-1, -1);
        this.mousePressPos = (0, $587dd1aab7f85c46$exports).fromValues(-1, -1);
        this.gpuBuffer = device.createBuffer({
            size: size,
            usage: GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST | GPUBufferUsage.COPY_SRC,
            label: `DebugDrawGPU GPU Buffer`
        });
    }
    parseDebugDrawBuffer(view) {
        const count = view.getUint32(0, true);
        let flags = 4;
        let offs = 8;
        const end = offs + count;
        while(offs < end){
            const messageType = view.getUint32(offs++ * 4, true);
            switch(messageType){
                case 0:
                    {
                        const v = !!view.getUint32(offs++ * 4, true);
                        flags &= -5;
                        flags |= v ? 4 : 0;
                    }
                    break;
                case 1:
                    {
                        const space = view.getUint32(offs++ * 4, true);
                        flags &= ~$2d8bc665070e6403$var$SpaceMask;
                        flags |= space;
                    }
                    break;
                case 3:
                    {
                        const p0 = (0, $8db1b5da822cad85$exports).fromValues(view.getFloat32(offs++ * 4, true), view.getFloat32(offs++ * 4, true), view.getFloat32(offs++ * 4, true));
                        const r = view.getFloat32(offs++ * 4, true);
                        const color = {
                            r: view.getFloat32(offs++ * 4, true),
                            g: view.getFloat32(offs++ * 4, true),
                            b: view.getFloat32(offs++ * 4, true),
                            a: view.getFloat32(offs++ * 4, true)
                        };
                        this.debugDraw.drawSphereLine(p0, r, color, 32, {
                            flags: flags
                        });
                    }
                    break;
                case 2:
                    {
                        const p0 = (0, $8db1b5da822cad85$exports).fromValues(view.getFloat32(offs++ * 4, true), view.getFloat32(offs++ * 4, true), view.getFloat32(offs++ * 4, true));
                        const p1 = (0, $8db1b5da822cad85$exports).fromValues(view.getFloat32(offs++ * 4, true), view.getFloat32(offs++ * 4, true), view.getFloat32(offs++ * 4, true));
                        const color = {
                            r: view.getFloat32(offs++ * 4, true),
                            g: view.getFloat32(offs++ * 4, true),
                            b: view.getFloat32(offs++ * 4, true),
                            a: view.getFloat32(offs++ * 4, true)
                        };
                        this.debugDraw.drawLine(p0, p1, color, color, {
                            flags: flags
                        });
                    }
                    break;
                case 4:
                    {
                        const p0 = (0, $8db1b5da822cad85$exports).fromValues(view.getFloat32(offs++ * 4, true), view.getFloat32(offs++ * 4, true), view.getFloat32(offs++ * 4, true));
                        const mag = view.getFloat32(offs++ * 4, true);
                        const color = {
                            r: view.getFloat32(offs++ * 4, true),
                            g: view.getFloat32(offs++ * 4, true),
                            b: view.getFloat32(offs++ * 4, true),
                            a: view.getFloat32(offs++ * 4, true)
                        };
                        this.debugDraw.drawLocator(p0, mag, color, {
                            flags: flags
                        });
                    }
                    break;
                case 5:
                    {
                        const v0 = view.getFloat32(offs++ * 4, true);
                        this.debugDraw.screenPrintText(`${v0.toFixed(2)}`);
                    }
                    break;
                case 6:
                    {
                        const v0 = view.getFloat32(offs++ * 4, true), v1 = view.getFloat32(offs++ * 4, true);
                        this.debugDraw.screenPrintText(`${v0.toFixed(2)}, ${v1.toFixed(2)}`);
                    }
                    break;
                case 7:
                    {
                        const v0 = view.getFloat32(offs++ * 4, true), v1 = view.getFloat32(offs++ * 4, true), v2 = view.getFloat32(offs++ * 4, true);
                        this.debugDraw.screenPrintText(`${v0.toFixed(2)}, ${v1.toFixed(2)}, ${v2.toFixed(2)}`);
                    }
                    break;
                case 8:
                    {
                        const v0 = view.getFloat32(offs++ * 4, true), v1 = view.getFloat32(offs++ * 4, true), v2 = view.getFloat32(offs++ * 4, true), v3 = view.getFloat32(offs++ * 4, true);
                        this.debugDraw.screenPrintText(`${v0.toFixed(2)}, ${v1.toFixed(2)}, ${v2.toFixed(2)}, ${v3.toFixed(2)}`);
                    }
                    break;
            }
        }
    }
    mapSubmittedFrames() {
        for(let i = 0; i < this.submittedFrames.length; i++){
            const frame = this.submittedFrames[i];
            if (frame.mapState === "unmapped") frame.mapAsync(GPUMapMode.READ);
        }
    }
    updateFromFinishedFrames() {
        for(let i = 0; i < this.submittedFrames.length; i++){
            const frame = this.submittedFrames[i];
            if (frame.mapState === "mapped") {
                const results = new DataView(frame.getMappedRange());
                this.parseDebugDrawBuffer(results);
                frame.unmap();
                this.submittedFrames.splice(i--, 1);
                this.framePool.push(frame);
            }
        }
    }
    getFrame() {
        if (this.framePool.length > 0) return this.framePool.pop();
        else return this.device.createBuffer({
            size: this.size,
            usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ,
            label: `DebugDrawGPU CPU Readback Buffer`
        });
    }
    beginFrame(mouseX, mouseY, mouseButtons) {
        this.mapSubmittedFrames();
        (0, $587dd1aab7f85c46$exports).set(this.mouseHoverPos, mouseX, mouseY);
        if (mouseButtons !== 0) (0, $587dd1aab7f85c46$exports).set(this.mousePressPos, mouseX, mouseY);
        // Overwrite the header with new data.
        const headerData = new Uint32Array(8);
        headerData[4] = this.mouseHoverPos[0];
        headerData[5] = this.mouseHoverPos[1];
        headerData[6] = this.mousePressPos[0];
        headerData[7] = this.mousePressPos[1];
        this.device.queue.writeBuffer(this.gpuBuffer, 0, headerData);
    }
    endFrame(cmd) {
        this.mapSubmittedFrames();
        this.updateFromFinishedFrames();
        const readbackFrame = this.getFrame();
        cmd.copyBufferToBuffer(this.gpuBuffer, 0, readbackFrame, 0, this.size);
        this.submittedFrames.push(readbackFrame);
    }
}
var $2d8bc665070e6403$var$DebugDrawMessageType;
const $2d8bc665070e6403$export$fcd0ece4145ed9a0 = `
struct DebugDraw_Buffer {
    @size(16)
    size: atomic<u32>, // u32 count

    mouse_hover_pos: vec2i, // pixel position of the current mouse
    mouse_press_pos: vec2i, // pixel position of the last held mouse

    data: array<u32>,
};

// user code needs to write:
// @group(x) @binding(y) var<storage, read_write> gDebugDraw_buffer: DebugDraw_Buffer;

fn DebugDraw_getMouseHoverPos() -> vec2i {
    return gDebugDraw_buffer.mouse_hover_pos;
}

fn DebugDraw_getMousePressPos() -> vec2i {
    return gDebugDraw_buffer.mouse_press_pos;
}

/**
 * Sets all future debug draws to use depth tinting (if v is true), or traditional depth testing (if v is false).
 */
fn DebugDraw_setDepthTint(v: bool) {
    var offs = atomicAdd(&gDebugDraw_buffer.size, 2u);
    gDebugDraw_buffer.data[offs + 0u] = ${0};
    gDebugDraw_buffer.data[offs + 1u] = select(0u, 1u, v);
}

/**
 * Sets all future debug draws to use a world-space coordinate system.
 */
fn DebugDraw_setWorldSpace() {
    var offs = atomicAdd(&gDebugDraw_buffer.size, 2u);
    gDebugDraw_buffer.data[offs + 0u] = ${1};
    gDebugDraw_buffer.data[offs + 1u] = ${0};
}

/**
 * Sets all future debug draws to use a view-space coordinate system,
 * where +z points towards the camera.
 */
fn DebugDraw_setViewSpace() {
    var offs = atomicAdd(&gDebugDraw_buffer.size, 2u);
    gDebugDraw_buffer.data[offs + 0u] = ${1};
    gDebugDraw_buffer.data[offs + 1u] = ${1};
}

/**
 * Sets all future debug draws to use a screen-space coordinate system,
 * where all draws are at the near plane, and x and y range from -1,1 (top left) to 1,1 (bottom right).
 */
fn DebugDraw_setScreenSpace() {
    var offs = atomicAdd(&gDebugDraw_buffer.size, 2u);
    gDebugDraw_buffer.data[offs + 0u] = ${1};
    gDebugDraw_buffer.data[offs + 1u] = ${2};
}

fn DebugDraw_drawLine(p0: vec3f, p1: vec3f, color0: vec4f) {
    var offs = atomicAdd(&gDebugDraw_buffer.size, 11u);
    gDebugDraw_buffer.data[offs + 0u] = ${2};
    gDebugDraw_buffer.data[offs + 1u] = bitcast<u32>(p0.x);
    gDebugDraw_buffer.data[offs + 2u] = bitcast<u32>(p0.y);
    gDebugDraw_buffer.data[offs + 3u] = bitcast<u32>(p0.z);
    gDebugDraw_buffer.data[offs + 4u] = bitcast<u32>(p1.x);
    gDebugDraw_buffer.data[offs + 5u] = bitcast<u32>(p1.y);
    gDebugDraw_buffer.data[offs + 6u] = bitcast<u32>(p1.z);
    gDebugDraw_buffer.data[offs + 7u] = bitcast<u32>(color0.x);
    gDebugDraw_buffer.data[offs + 8u] = bitcast<u32>(color0.y);
    gDebugDraw_buffer.data[offs + 9u] = bitcast<u32>(color0.z);
    gDebugDraw_buffer.data[offs + 10u] = bitcast<u32>(color0.w);
}

fn DebugDraw_drawSphere(p0: vec3f, radius: f32, color0: vec4f) {
    var offs = atomicAdd(&gDebugDraw_buffer.size, 9u);
    gDebugDraw_buffer.data[offs + 0u] = ${3};
    gDebugDraw_buffer.data[offs + 1u] = bitcast<u32>(p0.x);
    gDebugDraw_buffer.data[offs + 2u] = bitcast<u32>(p0.y);
    gDebugDraw_buffer.data[offs + 3u] = bitcast<u32>(p0.z);
    gDebugDraw_buffer.data[offs + 4u] = bitcast<u32>(radius);
    gDebugDraw_buffer.data[offs + 5u] = bitcast<u32>(color0.x);
    gDebugDraw_buffer.data[offs + 6u] = bitcast<u32>(color0.y);
    gDebugDraw_buffer.data[offs + 7u] = bitcast<u32>(color0.z);
    gDebugDraw_buffer.data[offs + 8u] = bitcast<u32>(color0.w);
}

fn DebugDraw_drawLocator(p0: vec3f, mag: f32, color0: vec4f) {
    var offs = atomicAdd(&gDebugDraw_buffer.size, 9u);
    gDebugDraw_buffer.data[offs + 0u] = ${4};
    gDebugDraw_buffer.data[offs + 1u] = bitcast<u32>(p0.x);
    gDebugDraw_buffer.data[offs + 2u] = bitcast<u32>(p0.y);
    gDebugDraw_buffer.data[offs + 3u] = bitcast<u32>(p0.z);
    gDebugDraw_buffer.data[offs + 4u] = bitcast<u32>(mag);
    gDebugDraw_buffer.data[offs + 5u] = bitcast<u32>(color0.x);
    gDebugDraw_buffer.data[offs + 6u] = bitcast<u32>(color0.y);
    gDebugDraw_buffer.data[offs + 7u] = bitcast<u32>(color0.z);
    gDebugDraw_buffer.data[offs + 8u] = bitcast<u32>(color0.w);
}

fn DebugDraw_screenPrintFloat1(v: f32) {
    var offs = atomicAdd(&gDebugDraw_buffer.size, 2u);
    gDebugDraw_buffer.data[offs + 0u] = ${5};
    gDebugDraw_buffer.data[offs + 1u] = bitcast<u32>(v);
}

fn DebugDraw_screenPrintFloat2(v: vec2f) {
    var offs = atomicAdd(&gDebugDraw_buffer.size, 3u);
    gDebugDraw_buffer.data[offs + 0u] = ${6};
    gDebugDraw_buffer.data[offs + 1u] = bitcast<u32>(v.x);
    gDebugDraw_buffer.data[offs + 2u] = bitcast<u32>(v.y);
}

fn DebugDraw_screenPrintFloat3(v: vec3f) {
    var offs = atomicAdd(&gDebugDraw_buffer.size, 4u);
    gDebugDraw_buffer.data[offs + 0u] = ${7};
    gDebugDraw_buffer.data[offs + 1u] = bitcast<u32>(v.x);
    gDebugDraw_buffer.data[offs + 2u] = bitcast<u32>(v.y);
    gDebugDraw_buffer.data[offs + 3u] = bitcast<u32>(v.z);
}

fn DebugDraw_screenPrintFloat4(v: vec4f) {
    var offs = atomicAdd(&gDebugDraw_buffer.size, 5u);
    gDebugDraw_buffer.data[offs + 0u] = ${8};
    gDebugDraw_buffer.data[offs + 1u] = bitcast<u32>(v.x);
    gDebugDraw_buffer.data[offs + 2u] = bitcast<u32>(v.y);
    gDebugDraw_buffer.data[offs + 3u] = bitcast<u32>(v.z);
    gDebugDraw_buffer.data[offs + 4u] = bitcast<u32>(v.w);
}
`;


class $b4e14b6b8da86996$var$Plane {
    constructor(device, colorTextureFormat, debugDraw){
        this.worldFromModelMatrix = (0, $90bfe889a3a444a8$exports).create();
        this.vertexBuffer = device.createBuffer({
            size: 80,
            usage: GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST,
            label: `Plane`
        });
        this.indexBuffer = device.createBuffer({
            size: 12,
            usage: GPUBufferUsage.INDEX | GPUBufferUsage.COPY_DST,
            label: `Plane`
        });
        const vertexData = new Float32Array([
            -1,
            0,
            -1,
            0,
            0,
            1,
            0,
            -1,
            1,
            0,
            1,
            0,
            1,
            1,
            1,
            -1,
            0,
            1,
            0,
            1
        ]);
        device.queue.writeBuffer(this.vertexBuffer, 0, vertexData);
        const indexData = new Uint16Array([
            0,
            1,
            2,
            0,
            2,
            3
        ]);
        device.queue.writeBuffer(this.indexBuffer, 0, indexData);
        const textureData = new Uint8Array([
            0xCC,
            0xCC,
            0xCC,
            0xCC,
            0x77,
            0x77,
            0x77,
            0x77,
            0x77,
            0x77,
            0x77,
            0x77,
            0xCC,
            0xCC,
            0xCC,
            0xCC
        ]);
        this.texture = device.createTexture({
            size: [
                2,
                2
            ],
            format: "rgba8unorm",
            usage: GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST,
            label: `Checkerboard`
        });
        device.queue.writeTexture({
            texture: this.texture
        }, textureData, {
            bytesPerRow: 8
        }, [
            2,
            2
        ]);
        const shaderModule = this.createShaderModule(device);
        this.pso = device.createRenderPipeline({
            layout: "auto",
            vertex: {
                module: shaderModule,
                entryPoint: "main_vs",
                buffers: [
                    {
                        attributes: [
                            {
                                shaderLocation: 0,
                                format: "float32x3",
                                offset: 0
                            },
                            {
                                shaderLocation: 1,
                                format: "float32x2",
                                offset: 12
                            }
                        ],
                        arrayStride: 20
                    }
                ]
            },
            fragment: {
                module: shaderModule,
                entryPoint: "main_ps",
                targets: [
                    {
                        format: colorTextureFormat
                    }
                ]
            },
            depthStencil: {
                format: "depth24plus",
                depthCompare: "greater",
                depthWriteEnabled: true
            },
            label: `Plane`
        });
        this.sampler = device.createSampler({
            addressModeU: `repeat`,
            addressModeV: `repeat`,
            minFilter: `nearest`,
            magFilter: `nearest`,
            label: `Plane`
        });
        this.uniformBuffer = device.createBuffer({
            size: 128,
            usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST
        });
        this.bindGroup = device.createBindGroup({
            layout: this.pso.getBindGroupLayout(0),
            entries: [
                {
                    binding: 0,
                    resource: {
                        buffer: this.uniformBuffer
                    }
                },
                {
                    binding: 1,
                    resource: this.texture.createView()
                },
                {
                    binding: 2,
                    resource: this.sampler
                },
                {
                    binding: 3,
                    resource: {
                        buffer: debugDraw.getGPUBuffer()
                    }
                }
            ]
        });
        (0, $90bfe889a3a444a8$exports).scale(this.worldFromModelMatrix, this.worldFromModelMatrix, [
            10,
            10,
            10
        ]);
    }
    draw(device, clipFromWorldMatrix, pass) {
        const data = new Float32Array(this.uniformBuffer.size / 4);
        data.set(clipFromWorldMatrix, 0);
        data.set(this.worldFromModelMatrix, 16);
        device.queue.writeBuffer(this.uniformBuffer, 0, data);
        pass.setPipeline(this.pso);
        pass.setBindGroup(0, this.bindGroup);
        pass.setVertexBuffer(0, this.vertexBuffer);
        pass.setIndexBuffer(this.indexBuffer, "uint16");
        pass.drawIndexed(6);
    }
    createShaderModule(device) {
        const code = `
struct ViewData {
    clip_from_world: mat4x4f,
    world_from_model: mat4x4f,
};

@group(0) @binding(0) var<uniform> view_data: ViewData;
@group(0) @binding(1) var plane_texture: texture_2d<f32>;
@group(0) @binding(2) var point_sampler: sampler;

@group(0) @binding(3) var<storage, read_write> gDebugDraw_buffer: DebugDraw_Buffer;

struct VertexOutput {
    @builtin(position) position: vec4f,
    @location(0) uv: vec2f,
    @location(1) world_position: vec3f,
};

@vertex
fn main_vs(@location(0) position: vec3f, @location(1) uv: vec2f) -> VertexOutput {
    var out: VertexOutput;
    out.position = view_data.clip_from_world * view_data.world_from_model * vec4f(position, 1.0f);
    out.uv = uv * vec2f(10.0f);
    out.world_position = (view_data.world_from_model * vec4f(position, 1.0f)).xyz;
    return out;
}

${(0, $2d8bc665070e6403$export$fcd0ece4145ed9a0)}

@fragment
fn main_ps(vertex: VertexOutput) -> @location(0) vec4f {
    var color = textureSample(plane_texture, point_sampler, vertex.uv);

    if (all(DebugDraw_getMouseHoverPos().xy == vec2i(vertex.position.xy))) {
        DebugDraw_drawSphere(vertex.world_position.xyz, 1.0f, vec4f(0.0f, 1.0f, 0.0f, 1.0f));
        // DebugDraw_screenPrintFloat3(vertex.world_position.xyz);
        DebugDraw_screenPrintFloat4(color);
    }

    if (all(DebugDraw_getMousePressPos().xy == vec2i(vertex.position.xy))) {
        DebugDraw_drawLocator(vertex.world_position.xyz, 0.5f, vec4f(0.0f, 0.0f, 1.0f, 1.0f));
    }

    return color;
}
`;
        return device.createShaderModule({
            code: code,
            label: `Plane `
        });
    }
}
class $b4e14b6b8da86996$var$MouseTracker {
    constructor(canvas){
        this.canvas = canvas;
        this.x = -1;
        this.y = -1;
        this.buttons = 0;
        this.canvas.addEventListener("mousemove", this.update.bind(this));
        this.canvas.addEventListener("mousedown", this.update.bind(this));
        this.canvas.addEventListener("mouseup", this.update.bind(this));
    }
    update(e) {
        this.x = e.offsetX * window.devicePixelRatio;
        this.y = e.offsetY * window.devicePixelRatio;
        this.buttons = e.buttons;
    }
}
function $b4e14b6b8da86996$export$59b33278b5b2fc8a(canvas, width, height, devicePixelRatio) {
    const nw = width * devicePixelRatio;
    const nh = height * devicePixelRatio;
    if (canvas.width === nw && canvas.height === nh) return;
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;
    canvas.width = nw;
    canvas.height = nh;
}
class $b4e14b6b8da86996$var$Main {
    constructor(){
        this.clipFromViewMatrix = (0, $90bfe889a3a444a8$exports).create();
        this.viewFromWorldMatrix = (0, $90bfe889a3a444a8$exports).create();
        this.clipFromWorldMatrix = (0, $90bfe889a3a444a8$exports).create();
        this.update = ()=>{
            this.updateCamera();
            this.debugDraw.beginFrame(this.canvas.width, this.canvas.height, this.mouseTracker.x, this.mouseTracker.y, this.mouseTracker.buttons);
            const colorTexture = this.ctx.getCurrentTexture();
            const renderPass = {
                colorAttachments: [
                    {
                        view: colorTexture.createView(),
                        clearValue: [
                            0.5,
                            0.5,
                            0.75,
                            1.0
                        ],
                        loadOp: "clear",
                        storeOp: "store"
                    }
                ],
                depthStencilAttachment: {
                    view: this.depthBuffer.createView(),
                    depthClearValue: 0.0,
                    depthLoadOp: "clear",
                    depthStoreOp: "store"
                }
            };
            const cmd = this.device.createCommandEncoder();
            const pass = cmd.beginRenderPass(renderPass);
            this.plane.draw(this.device, this.clipFromWorldMatrix, pass);
            pass.end();
            // DebugDraw example.
            const time = window.performance.now();
            this.debugDraw.drawSphereLine((0, $8db1b5da822cad85$exports).fromValues(Math.sin(time / 200) * 1.5, Math.sin(time / 300) * 0.2, Math.sin(time / 300 + 400)), 1, (0, $2d8bc665070e6403$export$b7d7e6f1815ae490), 32, {
                flags: (0, $2d8bc665070e6403$export$d630b5401a6a2fc8).DepthTint
            });
            this.debugDraw.endFrame(cmd, this.clipFromViewMatrix, this.viewFromWorldMatrix, colorTexture.createView(), this.depthBuffer.createView());
            this.device.queue.submit([
                cmd.finish()
            ]);
            requestAnimationFrame(this.update);
        };
        this.canvas = document.createElement("canvas");
        document.body.appendChild(this.canvas);
        this.mouseTracker = new $b4e14b6b8da86996$var$MouseTracker(this.canvas);
        this.init();
    }
    _onResize() {
        $b4e14b6b8da86996$export$59b33278b5b2fc8a(this.canvas, window.innerWidth, window.innerHeight, window.devicePixelRatio);
        this.depthBuffer = this.device.createTexture({
            size: [
                this.canvas.width,
                this.canvas.height
            ],
            format: "depth24plus",
            usage: GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.TEXTURE_BINDING
        });
    }
    async init() {
        const adapter = await navigator.gpu.requestAdapter();
        const device = await adapter?.requestDevice();
        if (device === undefined) throw "whoops";
        const colorTextureFormat = navigator.gpu.getPreferredCanvasFormat();
        this.device = device;
        this.ctx = this.canvas.getContext("webgpu");
        this.ctx.configure({
            device: device,
            format: colorTextureFormat
        });
        this.debugDraw = new (0, $2d8bc665070e6403$export$8c1f62922c980a1a)(device, colorTextureFormat);
        this.plane = new $b4e14b6b8da86996$var$Plane(device, colorTextureFormat, this.debugDraw);
        window.onresize = this._onResize.bind(this);
        this._onResize();
        requestAnimationFrame(this.update);
    }
    updateCamera() {
        (0, $90bfe889a3a444a8$exports).lookAt(this.viewFromWorldMatrix, [
            0,
            10,
            20
        ], [
            0,
            0,
            0
        ], [
            0,
            1,
            0
        ]);
        (0, $90bfe889a3a444a8$exports).perspectiveZO(this.clipFromViewMatrix, Math.PI / 3, this.canvas.width / this.canvas.height, 0.1, Infinity);
        // reverse depth
        (0, $90bfe889a3a444a8$exports).mul(this.clipFromViewMatrix, (0, $90bfe889a3a444a8$exports).fromValues(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, -1, 0, 0, 0, 1, 1), this.clipFromViewMatrix);
        (0, $90bfe889a3a444a8$exports).mul(this.clipFromWorldMatrix, this.clipFromViewMatrix, this.viewFromWorldMatrix);
    }
}
function $b4e14b6b8da86996$var$main() {
    const main = new $b4e14b6b8da86996$var$Main();
    window.main = main;
}
$b4e14b6b8da86996$var$main();


//# sourceMappingURL=index.a801aecc.js.map
